import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";

const STORAGE_KEY = "yaprio-language";
const LanguageContext = createContext({ language: "en", setLanguage: () => {}, t: (value) => value });

const JA = {
  "People currently on Yaprio": "現在Yaprioを利用中のユーザー",
  "No other members are online right now.": "現在オンラインのメンバーはいません。",
  "Chat rules": "チャットのルール",
  "Be respectful": "相手を尊重しましょう",
  "No hate speech": "ヘイトスピーチ禁止",
  "No NSFW content": "成人向けコンテンツ禁止",
  "Keep it friendly": "友好的な会話を心がけましょう",
  "Have fun 💗": "楽しみましょう 💗",
  "Tips": "ヒント",
  "Use @username to mention someone": "@ユーザー名でメンションできます",
  "React to messages you like": "気に入ったメッセージにリアクションしましょう",
  "Help make Yaprio a positive place": "Yaprioを前向きな場所にしましょう",
  "Quick Actions": "クイックアクション",
  "Same people.": "同じ人たち。",
  "Different conversations.": "違う会話。",
  "Create a group": "グループを作成",
  "Instant": "すぐにチャット",
  "Realtime chat": "リアルタイムチャット",
  "Voice notes": "ボイスメッセージ",
  "Social": "交流",
  "Reactions & replies": "リアクションと返信",
  "No incoming requests.": "受信したリクエストはありません。",
  "No follow requests.": "フォローリクエストはありません。",
  "Requests": "リクエスト",
  "No photos yet — add your first one!": "写真はまだありません。最初の写真を追加しましょう！",
  "Upload banner": "バナーをアップロード",
  "Your Answer": "あなたの回答",
  "History": "履歴",
  "Sign-in method": "ログイン方法",
  "Admin account": "管理者アカウント",
  "Calls": "通話",
  "Social activity": "ソーシャルアクティビティ",
  "Ghost Mode": "ゴーストモード",
  "Username Color": "ユーザー名の色",
  "Selected": "選択中",
  "Upload profile banner": "プロフィールバナーをアップロード",
  "Legend": "レジェンド",
  "YC message bonus": "YCメッセージボーナス",
  "Daily login bonus": "毎日のログインボーナス",
  "Profile role badge": "プロフィールのロールバッジ",
  "Username (with or without @)": "ユーザー名（@あり・なし）",
  "Sending…": "送信中…",
  "Your profile": "あなたのプロフィール",
  "Suggest": "提案",
  "Global": "グローバル",
  "Japan": "日本",
  "Japanese Community": "日本コミュニティ",
  "Global Community": "グローバルコミュニティ",
  "Choose community": "コミュニティを選択",
  "Comment": "コメント",
  "Share your world.": "あなたの世界をシェアしよう。",
  "Meet real people.": "本当のつながりを見つけよう。",
  "Post what you're doing, chat with friends, and be part of a positive community.": "近況を投稿し、友達とチャットして、前向きなコミュニティに参加しよう。",
  "Explore People": "ユーザーを探す",
  "For You": "おすすめ",
  "Posts from people you follow and your friends.": "フォロー中のユーザーや友達の投稿。",
  "Post must be 2000 characters or fewer.": "投稿は2000文字以内にしてください。",
  "Meet people, say hi and keep it real.": "新しい人と出会い、気軽に話そう。",
  "Connected": "接続済み",
  "Save Changes": "変更を保存",
  "Change Password": "パスワードを変更",
  "Delete Account": "アカウントを削除",
  "Report sent — thank you for helping improve Yaprio.": "報告を送信しました。Yaprioの改善にご協力いただきありがとうございます。",
  "Suggestion sent — thank you!": "ご提案ありがとうございます！",
  "Add a description or a screenshot first.": "説明またはスクリーンショットを追加してください。",
  "Signed out": "ログアウトしました",
  "No posts yet.": "まだ投稿はありません。",
  "Discover People": "ユーザーを探す",
  "Search real people by their @username.": "ユーザー名で検索できます。",
  "Real members of Yaprio — online first.": "Yaprioのメンバー。オンラインのユーザーを優先表示します。",
  "Search by username…": "ユーザー名で検索…",
  "No one matches": "一致するユーザーはいません",
  "No one else here yet": "まだ他のユーザーはいません",
  "Usernames only — check the spelling, or try a shorter search.": "ユーザー名で検索してください。スペルを確認するか、短くしてお試しください。",
  "member": "人",
  "members": "人",
  "on Yaprio": "がYaprioに参加しています",
  "Load more people": "もっと見る",
  "Manage notifications and alerts.": "通知とアラートを管理します。",
  "Control who can see your content and contact you.": "コンテンツを閲覧できる人や連絡できる人を管理します。",
  "Enable, disable and customize your active role.": "現在のロールを有効化、無効化、カスタマイズします。",
  "Manage active perks, username color and chat cosmetics.": "有効な特典、ユーザー名の色、チャットの装飾を管理します。",
  "Manage your account details and security.": "アカウント情報とセキュリティを管理します。",
  "Choose your preferred language.": "使用する言語を選択してください。",
  "Customize your Yaprio experience.": "Yaprioの表示をカスタマイズします。",
  "Version, help and more.": "バージョン、ヘルプなど。",
  "Manage your Yaprio experience, account and preferences.": "Yaprioの利用環境、アカウント、設定を管理します。",
  "Settings categories": "設定カテゴリ",
  "Perks & Styling": "特典とスタイル",
  "Theme & Display": "テーマと表示",
  "Friend requests and updates land here.": "友達リクエストや更新情報がここに表示されます。",
  "Mark all read": "すべて既読にする",
  "You're all caught up": "すべて確認しました",
  "When someone follows you or sends a friend request, you'll see it here.": "フォローや友達リクエストが届くと、ここに表示されます。",
  "Couldn't load people right now. Check your connection and try again.": "ユーザーを読み込めませんでした。接続を確認してもう一度お試しください。",
  "Couldn't load more people. Please try again.": "ユーザーをさらに読み込めませんでした。もう一度お試しください。",
  "That request is no longer pending.": "このリクエストは保留中ではありません。",
  "You're now friends with": "友達になりました：",
  "Yaprio Wallet": "Yaprioウォレット",
  "Earn YapCoins by being active, then spend them on roles, perks and upgrades.": "Yaprioで活動してYapCoinsを獲得し、ロールや特典、アップグレードに使いましょう。",
  "2 YC base · role bonuses up to 2×": "基本2 YC・ロールボーナス最大2倍",
  "Roles": "ロール",
  "Show off a role beside your name.": "名前の横にロールを表示します。",
  "Achievements": "実績",
  "Keep using Yaprio to unlock more.": "Yaprioを使い続けて実績を解除しましょう。",
  "Animated Rings": "アニメーションリング",
  "Buy a ring for 2,000 YC each. Your ring equips automatically after purchase, even without a premium role.": "リングは1つ2,000 YCです。購入後、プレミアムロールがなくても自動で装備されます。",
  "Perks": "特典",
  "Useful and cosmetic upgrades.": "便利な機能や見た目のアップグレード。",
  "Send YapCoins": "YapCoinsを送る",
  "Send YC to another Yaprio member.": "ほかのYaprioメンバーにYCを送ります。",
  "Transaction history": "取引履歴",
  "No transactions yet.": "取引履歴はまだありません。",
  "Your people, one place.": "大切な人たちを、ひとつの場所に。",
  "Create Group": "グループを作成",
  "Give your group a name and choose the friends to add.": "グループ名を入力し、追加する友達を選んでください。",
  "You don't have any friends to add.": "追加できる友達がいません。",
  "Edit Group": "グループを編集",
  "Change the group name. Only the group creator can edit it.": "グループ名を変更します。編集できるのは作成者のみです。",
  "Could not load follow counts.": "フォロー数を読み込めませんでした。",
  "Profile updated": "プロフィールを更新しました",
  "Profile photo must be 100MB or smaller.": "プロフィール写真は100MB以下にしてください。",
  "Profile photo updated": "プロフィール写真を更新しました",
  "Banner must be 100MB or smaller.": "バナー画像は100MB以下にしてください。",
  "Profile banner updated.": "プロフィールバナーを更新しました。",
  "Photo added to gallery": "写真をギャラリーに追加しました",
  "What's your vibe today?": "今日の気分は？",
  "Tell people a little about you…": "自己紹介を書いてください…",
  "Bio": "自己紹介",
  "Interests": "興味・関心",
  "Add an interest and press Enter": "興味を入力してEnterキーを押す",
  "Post removed by moderation": "モデレーションにより投稿が削除されました",
  "View Friends": "友達を見る",
  "User blocked": "ユーザーをブロックしました",
  "friend": "友達",
  "Random video chat, text chat, private messaging, and a real community — built for genuine connections instead of endless scrolling.": "ランダムビデオチャット、テキストチャット、プライベートメッセージ、そして本物のコミュニティ。延々とスクロールするのではなく、心の通うつながりを作りましょう。",
  "Meet people face-to-face": "ビデオで人と出会う",
  "Make Friends": "友達を作る",
  "Connect with new people": "新しい人とつながる",
  "Text Chat & Messaging": "テキストチャットとメッセージ",
  "Chat privately or in real time": "個別またはリアルタイムでチャット",
  "Explore": "見つける",
  "Find people around the world": "世界中の人を見つける",
  "Stay Safe": "安全に利用する",
  "Your privacy comes first": "プライバシーを最優先",
  "Search": "検索",
  "Create post": "投稿を作成",
  "Random Video": "ランダムビデオ",
  "good vibes only ♥": "ポジティブな雰囲気で ♥",
  "Sign up or log in with email and a unique username, or continue with Google.": "メールアドレスと固有のユーザー名で登録またはログインするか、Googleで続行してください。",
  "Email": "メールアドレス",
  "Back to login": "ログインに戻る",
  "If an account exists for that email, we've sent a reset link. It expires in 30 minutes.": "そのメールアドレスのアカウントが存在する場合、パスワード再設定リンクを送信しました。リンクの有効期限は30分です。",
  "or with email": "またはメールアドレスで",
  "Password": "パスワード",
  "Forgot password?": "パスワードをお忘れですか？",
  "you@example.com": "you@example.com",
  "yourname": "ユーザー名",
  "Reports are confidential and are reviewed by Yaprio moderators.": "報告内容は非公開で、Yaprioのモデレーターが確認します。",
  "Add more context (optional)": "詳細を追加（任意）",
  "Report this message": "このメッセージを報告",
  "Add any details that help us review (optional)": "確認に役立つ詳細を入力してください（任意）",
  "Claim your username": "ユーザー名を取得",
  "A quick note from Yaprio": "Yaprioからのお知らせ",
  "Notice": "お知らせ",
  "Until it’s fully finished, I won’t be promoting it yet.": "完全に完成するまで、まだ宣伝は行いません。",
  "Thank you for your patience and support! 💗": "お待ちいただき、ご支援くださりありがとうございます！💗",
  "Got it!": "了解しました！",
  "Close notice": "お知らせを閉じる",
  "Permanent ban options": "永久BANのオプション",
  "Profile report": "プロフィールの報告",
  "Reason:": "理由：",
  "Ban": "BAN",
  "Timeout": "一時利用停止",
  "Moderation": "モデレーション",
  "Review reports, remove content and manage bans.": "報告の確認、コンテンツの削除、BANの管理を行います。",
  "Refresh": "更新",
  "High priority": "優先度：高",
  "Reviewed": "確認済み",
  "Bans": "BAN一覧",
  "Audit log": "監査ログ",
  "Give YapCoins": "YapCoinsを付与",
  "Only administrators can create YC for members.": "メンバーにYCを付与できるのは管理者のみです。",
  "No high-priority reports": "優先度の高い報告はありません",
  "Nothing to review": "確認する項目はありません",
  "No profile reports": "プロフィールの報告はありません",
  "No site reports": "サイトの報告はありません",
  "No suggestions": "提案はありません",
  "No reviewed reports": "確認済みの報告はありません",
  "Amount": "数量",
  "Reason (optional)": "理由（任意）",
  "No bans yet": "BANはまだありません",
  "No admin actions yet": "管理者の操作履歴はまだありません",
  "Choose a new password to sign back in.": "新しいパスワードを設定して、再度ログインしてください。",
  "Password updated!": "パスワードを更新しました！",
  "Redirecting you to Yaprio…": "Yaprioに移動しています…",
  "Confirm password": "パスワードを確認",
  "At least 8 characters": "8文字以上",
  "Add a screenshot / picture": "スクリーンショット／画像を追加",
  "(optional)": "（任意）",
  "Ready to upload": "アップロード準備完了",
  "Open navigation menu": "ナビゲーションメニューを開く",
  "Discover people": "ユーザーを探す",
  "Remove picture": "画像を削除",
  "Choose how Yaprio looks on your device. System follows your device setting.": "デバイスでのYaprioの表示方法を選択します。「システム」はデバイスの設定に従います。",
  "Change password": "パスワードを変更",
  "Use a new password to keep your account secure.": "アカウントを安全に保つため、新しいパスワードを使用してください。",
  "New password (8+ characters)": "新しいパスワード（8文字以上）",
  "Change your username?": "ユーザー名を変更しますか？",
  "Delete your account?": "アカウントを削除しますか？",
  "Your password": "パスワード",
  "Re-enter your password": "パスワードをもう一度入力してください",
  "Save": "保存",
  "Edit": "編集",
  "Loading...": "読み込み中…",
  "Something went wrong": "問題が発生しました",
  "Send": "送信",
  "Offline": "オフライン",
  "Like": "いいね",
  "Share": "共有",
  "See more": "もっと見る",
  "See less": "折りたたむ",
  "No results found": "結果が見つかりません",
  "No notifications yet": "通知はまだありません",
  "Create": "作成",
  "Sign in": "ログイン",
  "Sign out": "ログアウト",
  "Wallet": "ウォレット",
  "Shop": "ショップ",
  "Store": "ストア",
  "English": "英語",
  "Japanese": "日本語",
  "Type a message...": "メッセージを入力…",
  "Write a message...": "メッセージを書く…",
  "What's happening?": "今何をしていますか？",
  "Add a comment...": "コメントを追加…",
  "Username": "ユーザー名",
  "Reset password": "パスワードをリセット",
  "Terms of Service": "利用規約",
  "Privacy Policy": "プライバシーポリシー",
  "No": "いいえ",
  "Yes": "はい",
  "Done": "完了",
  "Continue": "続行",
  "Submit": "送信",
  "Search users...": "ユーザーを検索…",
  "Search people...": "ユーザーを検索…",
  "Search messages...": "メッセージを検索…",
  "Type your message...": "メッセージを入力…",
  "Write a reply...": "返信を書く…",
  "Add details...": "詳細を追加…",
  "Optional": "任意",
  "Required": "必須",
  "Copied!": "コピーしました！",
  "Copy": "コピー",
  "View profile": "プロフィールを見る",
  "View all": "すべて表示",
  "Show more": "もっと見る",
  "Show less": "折りたたむ",
  "Clear": "クリア",
  "Apply": "適用",
  "Update": "更新",
  "Updated": "更新しました",
  "Success": "成功",
  "Error": "エラー",
  "Failed": "失敗しました",
  "Retry": "再試行",
  "Go home": "ホームへ",
  "Page not found": "ページが見つかりません",
  "Feature coming soon": "この機能は近日公開予定です",
  "No users found": "ユーザーが見つかりません",
  "No friends found": "友達が見つかりません",
  "No messages found": "メッセージが見つかりません",
  "No posts found": "投稿が見つかりません",
  "No conversations yet": "会話はまだありません",
  "No activity yet": "アクティビティはまだありません",
  "Start chatting": "チャットを始める",
  "Start a conversation": "会話を始める",
  "Send request": "リクエストを送信",
  "Friend request sent": "友達リクエストを送信しました",
  "Request sent": "リクエストを送信しました",
  "Reject request": "リクエストを拒否",
  "Unfriend": "友達を解除",
  "Unblocked": "ブロックを解除しました",
  "Mute": "ミュート",
  "Unmute": "ミュート解除",
  "Delete": "削除",
  "Delete post": "投稿を削除",
  "Edit post": "投稿を編集",
  "Discard changes": "変更を破棄",
  "Are you sure?": "本当によろしいですか？",
  "This action cannot be undone.": "この操作は取り消せません。",
  "Confirm": "確認",
  "Notification settings": "通知設定",
  "Account settings": "アカウント設定",
  "General": "一般",
  "Security": "セキュリティ",
  "Theme": "テーマ",
  "Light": "ライト",
  "Dark": "ダーク",
  "System": "システム",
  "Public": "公開",
  "Private": "非公開",
  "Everyone": "全員",
  "Nobody": "誰にも許可しない",
  "Today": "今日",
  "Yesterday": "昨日",
  "Just now": "たった今",
  "Yesterday at": "昨日",
  "minutes ago": "分前",
  "hours ago": "時間前",
  "days ago": "日前",
  "seconds ago": "秒前",
  "Report submitted": "報告を送信しました",
  "Message sent": "メッセージを送信しました",
  "Post created": "投稿を作成しました",
  "Post deleted": "投稿を削除しました",
  "Profile saved": "プロフィールを保存しました",
  "Settings saved": "設定を保存しました",
  "Changes saved": "変更を保存しました",
  "Could not save changes": "変更を保存できませんでした",
  "Could not load data": "データを読み込めませんでした",
  "Failed to load": "読み込みに失敗しました",
  "Connection lost": "接続が切断されました",
  "Reconnecting...": "再接続中…",
  "You're offline": "オフラインです",
  "You're online": "オンラインです",
  "No internet connection": "インターネットに接続されていません",
  "Upload image": "画像をアップロード",
  "Upload photo": "写真をアップロード",
  "Choose file": "ファイルを選択",
  "Choose image": "画像を選択",
  "Remove image": "画像を削除",
  "Upload failed": "アップロードに失敗しました",
  "File too large": "ファイルサイズが大きすぎます",
  "Invalid file type": "無効なファイル形式です",
  "Please try again.": "もう一度お試しください。",
  "Something went wrong.": "問題が発生しました。",
  "No data available": "データがありません",
  "Select an option": "選択してください",
  "Select all": "すべて選択",
  "Unselect all": "すべて解除",
  "Enable": "有効にする",
  "Disable": "無効にする",
  "Enabled": "有効",
  "Disabled": "無効",
  "On": "オン",
  "Off": "オフ",
  "Start": "開始",
  "Stop": "停止",
  "End": "終了",
  "Finish": "完了",
  "Welcome back": "おかえりなさい",
  "Create an account": "アカウントを作成",
  "Already have an account?": "すでにアカウントをお持ちですか？",
  "Don't have an account?": "アカウントをお持ちでないですか？",
  "Continue with Google": "Googleで続行",
  "Continue with email": "メールアドレスで続行",
  "Email address": "メールアドレス",
  "Enter your email": "メールアドレスを入力",
  "Enter your username": "ユーザー名を入力",
  "Enter your password": "パスワードを入力",
  "Password must be at least 8 characters": "パスワードは8文字以上で入力してください",
  "Invalid email address": "メールアドレスが正しくありません",
  "Incorrect password": "パスワードが正しくありません",
  "Account created": "アカウントを作成しました",
  "Welcome to Yaprio!": "Yaprioへようこそ！",
  "Log in to your account": "アカウントにログイン",
  "Reset link sent": "再設定リンクを送信しました",
  "Back to sign in": "ログインに戻る",
  "Account": "アカウント",
  "Profile settings": "プロフィール設定",
  "Blocked users": "ブロックしたユーザー",
  "Muted users": "ミュートしたユーザー",
  "Message requests": "メッセージリクエスト",
  "Friend requests": "友達リクエスト",
  "No pending requests": "保留中のリクエストはありません",
  "No pending notifications": "未読の通知はありません",
  "Mark all as read": "すべて既読にする",
  "Mark as read": "既読にする",
  "Mark as unread": "未読にする",
  "Unread": "未読",
  "Read": "既読",
  "Delivered": "配信済み",
  "Seen": "既読",
  "Typing...": "入力中…",
  "Recording voice...": "音声を録音中…",
  "Recording...": "録音中…",
  "Voice message": "音声メッセージ",
  "Replying to": "返信先：",
  "Forward": "転送",
  "Pin": "ピン留め",
  "Unpin": "ピン留めを解除",
  "Pinned": "ピン留め",
  "Unpinned": "ピン留めを解除しました",
  "Archive": "アーカイブ",
  "Unarchive": "アーカイブを解除",
  "Mute conversation": "会話をミュート",
  "Delete conversation": "会話を削除",
  "Clear conversation": "会話をクリア",
  "Group info": "グループ情報",
  "Add members": "メンバーを追加",
  "Remove member": "メンバーを削除",
  "New message": "新しいメッセージ",
  "New chat": "新しいチャット",
  "Start a chat": "チャットを始める",
  "Add a comment": "コメントを追加",
  "Post a comment": "コメントを投稿",
  "No comments yet": "コメントはまだありません",
  "View comments": "コメントを見る",
  "Hide comments": "コメントを非表示",
  "Like this post": "この投稿にいいね",
  "Unlike": "いいねを取り消す",
  "Share post": "投稿を共有",
  "Your story": "あなたのストーリー",
  "Add to story": "ストーリーに追加",
  "View story": "ストーリーを見る",
  "Story expired": "ストーリーの期限が切れました",
  "No stories yet": "ストーリーはまだありません",
  "Create story": "ストーリーを作成",
  "Upload story": "ストーリーをアップロード",
  "Viewers": "閲覧者",
  "Who can see my profile?": "プロフィールを閲覧できる人",
  "Who can message me?": "メッセージを送信できる人",
  "Who can send me friend requests?": "友達リクエストを送信できる人",
  "Everyone can message you": "誰でもメッセージを送信できます",
  "Friends only": "友達のみ",
  "Only me": "自分のみ",
  "Public profile": "公開プロフィール",
  "Private profile": "非公開プロフィール",
  "Save privacy settings": "プライバシー設定を保存",
  "Account deleted": "アカウントを削除しました",
  "This cannot be undone": "この操作は取り消せません",
  "Current username": "現在のユーザー名",
  "Username changed": "ユーザー名を変更しました",
  "Username is unavailable": "このユーザー名は使用できません",
  "Username is available": "このユーザー名は使用できます",
  "Check availability": "使用可能か確認",
  "Choose a username": "ユーザー名を選択",
  "Your bio": "自己紹介",
  "Edit bio": "自己紹介を編集",
  "Add bio": "自己紹介を追加",
  "Add interests": "興味・関心を追加",
  "Add a photo": "写真を追加",
  "Change photo": "写真を変更",
  "Change banner": "バナーを変更",
  "Cover photo": "カバー画像",
  "Photo gallery": "フォトギャラリー",
  "No photos yet": "写真はまだありません",
  "Followers list": "フォロワー一覧",
  "Following list": "フォロー中の一覧",
  "Mutual friends": "共通の友達",
  "Last seen": "最終オンライン",
  "Online now": "オンライン中",
  "Active now": "現在アクティブ",
  "Offline now": "現在オフライン",
  "Start video chat": "ビデオチャットを開始",
  "Camera on": "カメラオン",
  "Camera off": "カメラオフ",
  "Microphone on": "マイクオン",
  "Microphone off": "マイクオフ",
  "Enable camera": "カメラを有効にする",
  "Enable microphone": "マイクを有効にする",
  "Searching for a match...": "相手を探しています…",
  "Looking for someone...": "相手を探しています…",
  "No one is available right now": "現在利用できる相手はいません",
  "Next person": "次の相手",
  "Reconnect": "再接続",
  "End chat": "チャットを終了",
  "Leave chat": "チャットを退出",
  "You": "あなた",
  "Me": "自分",
  "Unknown": "不明",
  "Suggest an improvement": "改善案を提案",
  "Report a site issue": "サイトの問題を報告",
  "Tell us what you'd like to see on Yaprio. You can attach a screenshot too.": "Yaprioに追加してほしい機能や改善案を教えてください。スクリーンショットも添付できます。",
  "Tell us what went wrong on Yaprio. A screenshot helps us reproduce the issue.": "Yaprioで発生した問題を教えてください。スクリーンショットがあると問題を再現しやすくなります。",
  "New feature": "新機能",
  "Improvement": "改善",
  "Design / UI": "デザイン・画面表示",
  "Bug / broken feature": "バグ・機能の不具合",
  "UI / layout issue": "画面表示・レイアウトの問題",
  "Performance": "動作速度",
  "Security concern": "セキュリティ上の懸念",
  "What should we improve or add?": "どのような改善や機能追加を希望しますか？",
  "What happened? Tell us what you expected and what went wrong.": "何が起きましたか？期待していた動作と、実際に起きた問題を教えてください。",
  "Send suggestion": "提案を送信",
  "Reports are confidential. The reported user won't see who reported them.": "報告は非公開です。報告されたユーザーに、報告者が知らされることはありません。",
  "Sexual or explicit behavior": "性的・露骨な行為",
  "Threats or dangerous behavior": "脅迫・危険な行為",
  "Inappropriate behavior": "不適切な行為",
  "Thanks — our moderators will take a look.": "ありがとうございます。モデレーターが確認します。",
  "Scam": "詐欺",
  "Guest": "ゲスト",
  "Member": "メンバー",
  "Admin": "管理者",
  "Moderator": "モデレーター",
  "User": "ユーザー",
  "Role": "ロール",
  "Permissions": "権限",
  "Actions": "操作",
  "Status": "ステータス",
  "Date": "日付",
  "Time": "時刻",
  "Details": "詳細",
  "Description": "説明",
  "Title": "タイトル",
  "Name": "名前",
  "Type": "種類",
  "Category": "カテゴリ",
  "Priority": "優先度",
  "Low": "低",
  "Medium": "中",
  "High": "高",
  "Pending": "保留中",
  "Approved": "承認済み",
  "Rejected": "却下",
  "Open": "開く",
  "Closed": "終了",
  "Active": "有効",
  "Inactive": "無効",
  "Expired": "期限切れ",
  "Forever": "永久",
  "Week": "週間",
  "Month": "か月",
  "Year": "年",
  "Please provide a reason": "理由を入力してください",
  "Please select a reason": "理由を選択してください",
  "Other": "その他",
  "Spam": "スパム",
  "Harassment": "嫌がらせ",
  "Hate speech": "ヘイトスピーチ",
  "Violence": "暴力",
  "Nudity or sexual content": "ヌードまたは性的コンテンツ",
  "Impersonation": "なりすまし",
  "Scam or fraud": "詐欺",
  "Self-harm": "自傷行為",
  "Dangerous content": "危険なコンテンツ",
  "Something else": "その他",
  "Report reason": "報告理由",
  "Additional details": "追加の詳細",
  "Submit report": "報告を送信",
  "Report received": "報告を受け付けました",
  "Thank you for your report": "ご報告ありがとうございます",
  "This user has been banned": "このユーザーはBANされています",
  "Your account has been suspended": "アカウントは停止されています",
  "You have been blocked": "ブロックされています",
  "Access denied": "アクセスが拒否されました",
  "Unauthorized": "認証されていません",
  "Forbidden": "アクセス禁止",
  "Server error": "サーバーエラー",
  "Network error": "ネットワークエラー",
  "Request failed": "リクエストに失敗しました",
  "Please log in": "ログインしてください",
  "Session expired": "セッションの有効期限が切れました",
  "Sign in again": "再度ログインしてください",
  "Contact support": "サポートにお問い合わせください",
  "Help center": "ヘルプセンター",
  "Feedback": "フィードバック",
  "Send feedback": "フィードバックを送信",
  "Suggest a feature": "機能を提案",
  "Report a bug": "バグを報告",
  "Thanks for your feedback": "フィードバックありがとうございます",
  "No suggestions yet": "提案はまだありません",
  "Create suggestion": "提案を作成",
  "Submit suggestion": "提案を送信",
  "Admin dashboard": "管理者ダッシュボード",
  "User management": "ユーザー管理",
  "Reports": "報告",
  "Site reports": "サイトの報告",
  "User reports": "ユーザーの報告",
  "Content reports": "コンテンツの報告",
  "Moderation queue": "モデレーションキュー",
  "Review": "確認",
  "Mark as reviewed": "確認済みにする",
  "Unreviewed": "未確認",
  "Action taken": "対応済み",
  "No actions taken": "対応はありません",
  "Ban user": "ユーザーをBAN",
  "Unban user": "BANを解除",
  "Temporary ban": "一時BAN",
  "Permanent ban": "永久BAN",
  "Ban reason": "BANの理由",
  "Ban duration": "BAN期間",
  "IP address": "IPアドレス",
  "Delete user": "ユーザーを削除",
  "Restore": "復元",
  "Undo": "元に戻す",
  "Are you sure you want to continue?": "続行してもよろしいですか？",
  "Changes discarded": "変更を破棄しました",
  "No changes to save": "保存する変更はありません",
  "Preferences": "環境設定",
  "Appearance settings": "外観設定",
  "Save settings": "設定を保存",
  "Reset settings": "設定をリセット",
  "Default": "デフォルト",
  "Automatic": "自動",
  "Custom": "カスタム",
  "Select language": "言語を選択",
  "Choose language": "言語を選択",
  "Language changed": "言語を変更しました",
  "Japanese (日本語)": "日本語（日本語）",
  "English (US)": "英語（米国）",
  "Disable notifications": "通知を無効にする",
  "Push notifications": "プッシュ通知",
  "Email notifications": "メール通知",
  "Sound": "サウンド",
  "Sounds": "サウンド",
  "Message notifications": "メッセージ通知",
  "Friend notifications": "友達の通知",
  "Follow notifications": "フォロー通知",
  "New follower": "新しいフォロワー",
  "New like": "新しいいいね",
  "New comment": "新しいコメント",
  "New reply": "新しい返信",
  "New friend request": "新しい友達リクエスト",
  "New message from": "新しいメッセージ：",
  "Someone mentioned you": "あなたがメンションされました",
  "mentioned you": "あなたをメンションしました",
  "liked your post": "あなたの投稿にいいねしました",
  "commented on your post": "あなたの投稿にコメントしました",
  "replied to your comment": "あなたのコメントに返信しました",
  "started following you": "あなたをフォローし始めました",
  "sent you a friend request": "友達リクエストを送信しました",
  "accepted your friend request": "友達リクエストを承認しました",
  "No notifications": "通知はありません",
  "Clear all": "すべてクリア",
  "Delete all": "すべて削除",
  "You have no notifications yet": "通知はまだありません",
  "Welcome": "ようこそ",
  "Welcome to Yaprio": "Yaprioへようこそ",
  "Meet people.": "人と出会おう。",
  "Make friends.": "友達を作ろう。",
  "Talk face-to-face.": "顔を見て話そう。",
  "Get started": "始める",
  "I have an account": "アカウントをお持ちの方",
  "Log in": "ログイン",
  "Sign up": "新規登録",
  "No internet connection.": "インターネットに接続されていません。",
  "The request timed out": "リクエストがタイムアウトしました",
  "Please enter a valid email": "有効なメールアドレスを入力してください",
  "Passwords do not match": "パスワードが一致しません",
  "Username must be at least 3 characters": "ユーザー名は3文字以上にしてください",
  "Username can only contain letters, numbers, and underscores": "ユーザー名には英字、数字、アンダースコアのみ使用できます",
  "You must accept the terms": "利用規約に同意してください",
  "Terms and conditions": "利用規約",
  "By continuing, you agree to our Terms of Service and Privacy Policy.": "続行すると、利用規約とプライバシーポリシーに同意したことになります。",
  "Sign in with Google": "Googleでログイン",
  "Continue as guest": "ゲストとして続行",
  "Already registered?": "すでに登録済みですか？",
  "Create account": "アカウントを作成",
  "Send reset link": "再設定リンクを送信",
  "Check your email": "メールを確認してください",
  "Verification email sent": "確認メールを送信しました",
  "Verify your email": "メールアドレスを確認",
  "Resend email": "メールを再送信",
  "Email verified": "メールアドレスを確認しました",
  "Your session has expired": "セッションの有効期限が切れました",
  "Please refresh the page": "ページを更新してください",
  "Unexpected error": "予期しないエラー",
  "Something went wrong while saving": "保存中に問題が発生しました",
  "Could not save": "保存できませんでした",
  "Could not update": "更新できませんでした",
  "Could not delete": "削除できませんでした",
  "Could not upload": "アップロードできませんでした",
  "Could not send": "送信できませんでした",
  "Could not connect": "接続できませんでした",
  "Unable to load": "読み込めません",
  "Unable to save": "保存できません",
  "Unable to update": "更新できません",
  "Unable to delete": "削除できません",
  "No permission": "権限がありません",
  "Permission denied": "権限が拒否されました",
  "You don't have permission to do this": "この操作を行う権限がありません",
  "You are not allowed to do this": "この操作は許可されていません",
  "This field is required": "この項目は必須です",
  "Please fill out this field": "この項目を入力してください",
  "Please select an item": "項目を選択してください",
  "Please enter a value": "値を入力してください",
  "Please enter a message": "メッセージを入力してください",
  "Message cannot be empty": "メッセージを入力してください",
  "Post cannot be empty": "投稿内容を入力してください",
  "Please add some text": "テキストを入力してください",
  "Please enter at least 1 character": "1文字以上入力してください",
  "Maximum length exceeded": "最大文字数を超えています",
  "File uploaded": "ファイルをアップロードしました",
  "Image uploaded": "画像をアップロードしました",
  "Photo uploaded": "写真をアップロードしました",
  "Upload complete": "アップロード完了",
  "Uploading...": "アップロード中…",
  "Saving...": "保存中…",
  "Sending...": "送信中…",
  "Deleting...": "削除中…",
  "Updating...": "更新中…",
  "Loading more...": "さらに読み込み中…",
  "Load more": "さらに読み込む",
  "Show all": "すべて表示",
  "Hide": "非表示",
  "Show": "表示",
  "Expand": "展開",
  "Collapse": "折りたたむ",
  "Expand all": "すべて展開",
  "Collapse all": "すべて折りたたむ",
  "Sort by": "並べ替え",
  "Filter": "フィルター",
  "Filters": "フィルター",
  "Sort": "並べ替え",
  "Newest": "新着順",
  "Oldest": "古い順",
  "Most popular": "人気順",
  "Most recent": "最新",
  "Popular": "人気",
  "Trending": "トレンド",
  "Recommended": "おすすめ",
  "For you": "あなたへのおすすめ",
  "Following feed": "フォロー中のフィード",
  "Explore feed": "探索フィード",
  "Create a post": "投稿を作成",
  "Post something": "投稿する",
  "Share your thoughts": "考えを共有",
  "Add media": "メディアを追加",
  "Upload media": "メディアをアップロード",
  "Add video": "動画を追加",
  "Add link": "リンクを追加",
  "Add location": "場所を追加",
  "Tag people": "ユーザーをタグ付け",
  "Who can see this?": "誰が閲覧できますか？",
  "Post visibility": "投稿の公開範囲",
  "Everyone can see this": "誰でも閲覧できます",
  "Friends can see this": "友達が閲覧できます",
  "Only followers": "フォロワーのみ",
  "Post published": "投稿を公開しました",
  "Publish": "公開",
  "Publishing...": "公開中…",
  "Draft": "下書き",
  "Draft saved": "下書きを保存しました",
  "Discard": "破棄",
  "Discard post?": "投稿を破棄しますか？",
  "Delete this post?": "この投稿を削除しますか？",
  "Are you sure you want to delete this?": "本当に削除しますか？",
  "You can't undo this action.": "この操作は元に戻せません。",
  "No content yet": "コンテンツはまだありません",
  "Nothing here yet": "ここにはまだ何もありません",
  "It's quiet here": "ここはまだ静かです",
  "Be the first to post": "最初に投稿しましょう",
  "Start a new conversation": "新しい会話を始める",
  "Find your friends": "友達を探す",
  "Invite friends": "友達を招待",
  "Invite": "招待",
  "Invite sent": "招待を送信しました",
  "Copy link": "リンクをコピー",
  "Link copied": "リンクをコピーしました",
  "Share link": "リンクを共有",
  "Share profile": "プロフィールを共有",
  "Copy username": "ユーザー名をコピー",
  "Username copied": "ユーザー名をコピーしました",
  "Follow request sent": "フォローリクエストを送信しました",
  "Pending follow request": "フォローリクエスト保留中",
  "Accept follow request": "フォローリクエストを承認",
  "Reject follow request": "フォローリクエストを拒否",
  "Cancel request": "リクエストをキャンセル",
  "Request canceled": "リクエストをキャンセルしました",
  "No followers yet": "フォロワーはまだいません",
  "Not following anyone yet": "まだ誰もフォローしていません",
  "You aren't following anyone yet": "まだ誰もフォローしていません",
  "No mutual friends": "共通の友達はいません",
  "No users online": "オンラインのユーザーはいません",
  "People you may know": "知り合いかもしれない人",
  "Suggested users": "おすすめユーザー",
  "Discover new people": "新しいユーザーを見つける",
  "Search by username": "ユーザー名で検索",
  "Search by name": "名前で検索",
  "Clear search": "検索をクリア",
  "No matches": "一致するものがありません",
  "No matches found": "一致するものが見つかりません",
  "Try another search": "別のキーワードで検索してください",
  "Try a different search": "別のキーワードで検索してください",
  "Recently active": "最近アクティブ",
  "Active members": "アクティブなメンバー",
  "Online members": "オンラインのメンバー",
  "Member since": "登録日",
  "Joined": "参加日",
  "Joined Yaprio": "Yaprioに参加しました",
  "Last active": "最終アクティブ",
  "Profile not found": "プロフィールが見つかりません",
  "This account is private": "このアカウントは非公開です",
  "Account not found": "アカウントが見つかりません",
  "This user doesn't exist": "このユーザーは存在しません",
  "You have been logged out": "ログアウトしました",
  "Logged in successfully": "ログインしました",
  "Logged out successfully": "ログアウトしました",
  "Signed in successfully": "ログインしました",
  "Signed out successfully": "ログアウトしました",
  "Account updated": "アカウントを更新しました",
  "Profile updated successfully": "プロフィールを更新しました",
  "Your profile has been updated": "プロフィールを更新しました",
  "Changes have been saved": "変更を保存しました",
  "Your changes have been saved": "変更を保存しました",
  "No changes made": "変更はありません",
  "Nothing to save": "保存するものはありません",
  "Not available": "利用できません",
  "Unavailable": "利用不可",
  "Coming soon!": "近日公開！",
  "Under construction": "準備中",
  "This feature is under construction": "この機能は準備中です",
  "Back to settings": "設定に戻る",
  "Open profile": "プロフィールを開く",
  "Go to profile": "プロフィールへ",
  "Go to settings": "設定へ",
  "Manage account": "アカウントを管理",
  "Manage privacy": "プライバシーを管理",
  "Manage notifications": "通知を管理",
  "Account security": "アカウントのセキュリティ",
  "Change email": "メールアドレスを変更",
  "Update email": "メールアドレスを更新",
  "Email changed": "メールアドレスを変更しました",
  "Change password successfully": "パスワードを変更しました",
  "Password changed": "パスワードを変更しました",
  "Password updated successfully": "パスワードを更新しました",
  "Your password has been changed": "パスワードを変更しました",
  "Delete account permanently?": "アカウントを完全に削除しますか？",
  "Your account will be permanently deleted.": "アカウントは完全に削除されます。",
  "Type DELETE to confirm": "確認するにはDELETEと入力してください",
  "Type your username to confirm": "確認するためにユーザー名を入力してください",
  "Account deletion requested": "アカウント削除を受け付けました",
  "Account deletion failed": "アカウントの削除に失敗しました",
  "Your account has been deleted": "アカウントを削除しました",
  "Username change failed": "ユーザー名の変更に失敗しました",
  "That username is taken": "そのユーザー名はすでに使用されています",
  "Username already exists": "ユーザー名はすでに存在します",
  "Please choose another username": "別のユーザー名を選択してください",
  "Username cannot be changed right now": "現在ユーザー名を変更できません",
  "days": "日",
  "hours": "時間",
  "minutes": "分",
  "seconds": "秒",
  "Your account": "あなたのアカウント",
  "Sign in to continue": "続行するにはログインしてください",
  "Log in to continue": "続行するにはログインしてください",
  "You need to be logged in": "ログインが必要です",
  "Please sign in first": "先にログインしてください",
  "You must be logged in": "ログインしている必要があります",
  "Access restricted": "アクセスが制限されています",
  "This page is restricted": "このページへのアクセスは制限されています",
  "Only members can view this": "メンバーのみ閲覧できます",
  "Admin only": "管理者のみ",
  "Moderators only": "モデレーターのみ",
  "You are banned": "BANされています",
  "You are temporarily banned": "一時的にBANされています",
  "Ban expires": "BAN期限",
  "Account suspended": "アカウント停止中",
  "Account banned": "アカウントBAN済み",
  "Your account is banned": "アカウントはBANされています",
  "Appeal ban": "BANに異議申し立て",
  "Submit appeal": "異議申し立てを送信",
  "Appeal submitted": "異議申し立てを送信しました",
  "Appeal status": "異議申し立てのステータス",
  "Your appeal is pending": "異議申し立ては保留中です",
  "Appeal rejected": "異議申し立ては却下されました",
  "Appeal accepted": "異議申し立てが承認されました",
  "Edit Profile": "プロフィールを編集",
  "be real, be kind, belong ♥": "自分らしく、優しく、ここにいよう ♥",
  "Stories": "ストーリー",
  "Photos disappear after 24 hours.": "写真は24時間後に消えます。",
  "Your Story": "あなたのストーリー",
  "Loading more…": "さらに読み込み中…",
  "You're all caught up ✨": "すべて確認しました ✨",
  "Copy post link": "投稿リンクをコピー",
  "Remove photo": "写真を削除",
  "Close post": "投稿を閉じる",
  "Add another story": "ストーリーを追加",
  "Delete story": "ストーリーを削除",
  "Close story": "ストーリーを閉じる",
  "Reply to story": "ストーリーに返信",
  "Previous story": "前のストーリー",
  "Next story": "次のストーリー",
  "Close comments": "コメントを閉じる",
  "Cancel reply": "返信をキャンセル",
  "Manage your connections, requests and blocked users.": "つながり、リクエスト、ブロックしたユーザーを管理します。",
  "Incoming": "受信",
  "Follow requests": "フォローリクエスト",
  "No sent requests.": "送信済みのリクエストはありません。",
  "Stay connected with your people.": "友達とつながりましょう。",
  "New": "新着",
  "Group": "グループ",
  "Yaprio Messages": "Yaprioメッセージ",
  "Delete group": "グループを削除",
  "Leave group": "グループを退出",
  "Edit group": "グループを編集",
  "Story preview unavailable": "ストーリーのプレビューを利用できません",
  "Message deleted": "メッセージを削除しました",
  "edited": "編集済み",
  "Voice": "音声",
  "Game": "ゲーム",
  "Photo": "写真",
  "Expanded photo viewer": "写真を拡大表示",
  "Choose a friend to start chatting with.": "チャットを始める友達を選んでください。",
  "You don't have any friends yet.": "まだ友達はいません。",
  "Selected:": "選択中：",
  "Play a game": "ゲームをプレイ",
  "Tic-Tac-Toe": "三目並べ",
  "Quick 1v1 game · X goes first": "手軽な1対1ゲーム・先攻はX",
  "Connect 4": "コネクトフォー",
  "Drop pieces · get four in a row": "コマを落として4つ並べよう",
  "Chess": "チェス",
  "Classic 1v1 · White moves first": "定番の1対1・白が先手",
  "Clear chat search": "チャット検索をクリア",
  "Change group photo": "グループ写真を変更",
  "Level 5+ Chat Badge": "レベル5以上のチャットバッジ",
  "Group options": "グループのオプション",
  "Open photo": "写真を開く",
  "Message options": "メッセージのオプション",
  "Send photo": "写真を送信",
  "A happier internet, together. ❤️": "みんなで、もっと楽しいインターネットを。❤️",
  "Yaprio Public Chat": "Yaprioパブリックチャット",
  "Welcome 👋": "ようこそ 👋",
  "🌎 Anyone can join the conversation": "🌎 誰でも会話に参加できます",
  "💬 Say hi, reply, and meet people": "💬 あいさつや返信をして、新しい人と出会いましょう",
  "❤️ Keep it respectful and fun": "❤️ 相手を尊重し、楽しく過ごしましょう",
  "Got it — let's chat": "了解しました。チャットを始めましょう",
  "People are talking": "みんなが会話中",
  "You're muted from public chat": "パブリックチャットでミュートされています",
  "You can still message friends privately and use the rest of Yaprio normally.": "友達との個別メッセージや、Yaprioのほかの機能は通常どおり利用できます。",
  "Public match": "公開マッチ",
  "You found a player 🎮": "対戦相手が見つかりました 🎮",
  "Public Games": "パブリックゲーム",
  "Find someone waiting or open a game.": "待機中の相手を見つけるか、ゲームを開始しましょう。",
  "Join": "参加",
  "No one is waiting for a game right now.": "現在ゲームの相手を待っている人はいません。",
  "Start waiting": "待機を開始",
  "Remove this message?": "このメッセージを削除しますか？",
  "Remove message": "メッセージを削除",
  "Welcome to Public Chat": "パブリックチャットへようこそ",
  "Add emoji": "絵文字を追加",
  "Close game": "ゲームを閉じる",
  "Choose which alerts Yaprio can show you on this device.": "このデバイスでYaprioからの通知を許可するか選択してください。",
  "Your choices are saved automatically on this device.": "選択内容はこのデバイスに自動保存されます。",
  "Control who can see you and who can contact you. Changes save automatically.": "あなたを閲覧できる人や連絡できる人を管理します。変更は自動保存されます。",
  "Profile visibility": "プロフィールの公開範囲",
  "Choose who can open your profile.": "プロフィールを閲覧できる人を選択します。",
  "Photo visibility": "写真の公開範囲",
  "Control who can view your profile gallery.": "プロフィールのギャラリーを閲覧できる人を管理します。",
  "Choose whether anyone can send you a request.": "誰でもリクエストを送信できるようにするか選択します。",
  "Private messages": "プライベートメッセージ",
  "Control whether friends can message you.": "友達からのメッセージを許可するか管理します。",
  "Control who can call you.": "通話できる人を管理します。",
  "Random video chat": "ランダムビデオチャット",
  "Allow Yaprio to match you with other members in Random Video Chat.": "ランダムビデオチャットで、ほかのメンバーとのマッチングを許可します。",
  "Loading privacy settings…": "プライバシー設定を読み込み中…",
  "Roles & Abilities": "ロールと能力",
  "You don't currently own a role. Buy one from Wallet & Store to unlock role abilities.": "現在ロールを所有していません。ウォレット＆ストアで購入するとロールの能力が解放されます。",
  "Your role lasts 30 days. Turn it off or disable individual abilities whenever you want.": "ロールの有効期間は30日間です。いつでもロールをオフにしたり、個別の能力を無効にしたりできます。",
  "Role profile perks": "ロールのプロフィール特典",
  "Banner uploaded": "バナーをアップロードしました",
  "Remove banner": "バナーを削除",
  "Turn your active perks on or off. Every perk lasts 30 days from purchase.": "有効な特典をオン／オフにできます。各特典は購入から30日間有効です。",
  "No active perks": "有効な特典はありません",
  "Username color": "ユーザー名の色",
  "Everything you need to know about this version of Yaprio.": "このバージョンのYaprioについて知っておくべき情報です。",
  "Session": "セッション",
  "Sign out of Yaprio on this device.": "このデバイスでYaprioからログアウトします。",
  "Log out": "ログアウト",
  "Danger zone": "危険な操作",
  "Delete my account": "アカウントを削除",
  "Enable notifications": "通知を有効にする",
  "Allow random video chat": "ランダムビデオチャットを許可",
  "Enable role": "ロールを有効にする",
  "Animated avatar ring": "アバターのアニメーションリング",
  "OWNED": "所有済み",
  "UNLOCKED": "解除済み",
  "Confirm purchase": "購入を確定",
  "Are you sure you want to buy": "本当に購入しますか？",
  "for": "価格：",
  "? This will deduct the YC from your wallet.": "？ウォレットからYCが差し引かれます。",
  "This is how the world sees you on Yaprio.": "Yaprioで他の人に表示されるプロフィールです。",
  "Your profile banner preview": "プロフィールバナーのプレビュー",
  "Status message": "ステータスメッセージ",
  "Show off up to a few of your favourite moments.": "お気に入りの瞬間をいくつか紹介しましょう。",
  "What": "何",
  "Close list": "リストを閉じる",
  "No comments yet. Be the first!": "まだコメントはありません。最初にコメントしましょう！",
  "Couldn't load profile": "プロフィールを読み込めませんでした",
  "Go back": "戻る",
  "User not found": "ユーザーが見つかりません",
  "This account doesn't exist or is unavailable.": "このアカウントは存在しないか、利用できません。",
  "Requested": "リクエスト済み",
  "Follow request": "フォローリクエスト",
  "Friend requested": "友達リクエスト送信済み",
  "Accept friend request": "友達リクエストを承認",
  "Add friend": "友達を追加",
  "Demote": "降格",
  "Promote": "昇格",
  "This profile is private": "このプロフィールは非公開です",
  "Gallery": "ギャラリー",
  "Posts": "投稿",
  "No posts yet": "投稿はまだありません",
  "Remove post": "投稿を削除",
  "Gallery photo": "ギャラリーの写真",
  "Close gallery": "ギャラリーを閉じる",
  "Online": "オンライン",
  "Reply": "返信",
  "Message": "メッセージ",
  "Blocked": "ブロック中",
  "Accept": "承認",
  "Decline": "拒否",
  "Sent": "送信済み",
  "Back": "戻る",
  "Create group": "グループを作成",
  "Group name": "グループ名",
  "Notifications": "通知",
  "Language": "言語",
  "About Yaprio": "Yaprioについて",
  "Wallet & Store": "ウォレット＆ストア",
  "Public Chat": "パブリックチャット",
  "Random Chat": "ランダムチャット",
  "Profile": "プロフィール",
  "Friends": "友達",
  "Discover": "見つける",
  "Home": "ホーム",
  "Settings": "設定",
  "Messages": "メッセージ",
  "My Profile": "自分のプロフィール",
  "Create a Post": "投稿を作成",
  "Find People": "ユーザーを探す",
  "Open Messages": "メッセージを開く",
  "Close": "閉じる",
  "Previous": "前へ",
  "Search people": "ユーザーを検索",
  "Search by username...": "ユーザー名で検索…",
  "No users found.": "ユーザーが見つかりません。",
  "No friends to show": "表示する友達はいません",
  "New group": "新しいグループ",
  "Search friends": "友達を検索",
  "Search chats": "チャットを検索",
  "No chats found": "チャットが見つかりません",
  "Try a different name or message.": "別の名前やメッセージをお試しください。",
  "Start a conversation with a friend.": "友達との会話を始めましょう。",
  "No messages yet": "メッセージはまだありません",
  "Search conversations…": "会話を検索…",
  "Type a message…": "メッセージを入力…",
  "Send message": "メッセージを送信",
  "Send a message": "メッセージを送信",
  "Search users": "ユーザーを検索",
  "Search users…": "ユーザーを検索…",
  "No results": "結果がありません",
  "Show profile": "プロフィールを表示",
  "Unblock": "ブロック解除",
  "Remove friend": "友達を削除",
  "Unblock user": "ブロックを解除",
  "Report user": "ユーザーを報告",
  "Random Video Chat": "ランダムビデオチャット",
  "Looking for someone…": "相手を探しています…",
  "Ready to meet someone new?": "新しい人と出会う準備はできましたか？",
  "Camera preview unavailable": "カメラのプレビューを利用できません",
  "No friends yet": "まだ友達はいません",
  "Head to Discover to find people and send your first friend request.": "「見つける」でユーザーを探して、最初の友達リクエストを送りましょう。",
  "No blocked users": "ブロック中のユーザーはいません",
  "People you block won't be able to find you, message you, or send requests.": "ブロックしたユーザーは、あなたを検索したり、メッセージやリクエストを送ったりできません。",
  "Write something or add a photo.": "文章を書くか、写真を追加してください。",
  "Posted! 💗": "投稿しました！💗",
  "Add Photo": "写真を追加",
  "Post": "投稿",
  "Comments": "コメント",
  "comment": "件のコメント",
  "comments": "件のコメント",
  "Your Feed": "あなたのフィード",
  "Fresh posts from the Yaprio community.": "Yaprioコミュニティの最新投稿。",
  "Edit profile": "プロフィールを編集",
  "Follow": "フォロー",
  "Unfollow": "フォロー解除",
  "Followers": "フォロワー",
  "Following": "フォロー中",
  "Accept request": "リクエストを承認",
  "Decline request": "リクエストを拒否",
  "Current password": "現在のパスワード",
  "New password": "新しいパスワード",
  "Confirm new password": "新しいパスワードを確認",
  "Change username": "ユーザー名を変更",
  "Save changes": "変更を保存",
  "Privacy settings": "プライバシー設定",
  "Appearance": "外観",
  "Photo Gallery": "フォトギャラリー",
  "Remove": "削除",
  "Write a comment...": "コメントを書く…",
  "Join the conversation.": "会話に参加しましょう。",
  "Report post": "投稿を報告",
  "Report story": "ストーリーを報告",
  "About": "このアプリについて",
  "Game over": "ゲーム終了",
  "Record voice message": "音声メッセージを録音",
  "Send voice message": "音声メッセージを送信",
  "Close navigation menu": "ナビゲーションメニューを閉じる",
  "Navigation menu": "ナビゲーションメニュー",
  "Privacy": "プライバシー",
  "Control who can see and contact you.": "あなたを閲覧したり連絡したりできる人を管理します。",
  "Saving": "保存中",
  "Saved": "保存済み",
  "Who can message you": "メッセージを送信できる人",
  "Show online status": "オンライン状態を表示",
  "Let friends see when you're online.": "友達にオンライン状態を表示します。",
  "Show last seen": "最終オンライン時刻を表示",
  "Show when you were last active.": "最後にアクティブだった時刻を表示します。",
  "Appear in Random Chat": "ランダムチャットに表示",
  "Allow the random matching system to match you.": "ランダムマッチングシステムでマッチングできるようにします。",
  "New username": "新しいユーザー名",
  "Block sender": "送信者をブロック",
  "Answer publicly": "公開で回答",
  "Anonymous question": "匿名の質問",
  "Answer": "回答",
  "Ask an anonymous question": "匿名で質問する",
  "Ask anonymously": "匿名で質問する",
  "Your username won't be shown to the recipient.": "あなたのユーザー名は相手に表示されません。",
  "Answer publicly...": "公開で回答…",
  "Ask anything...": "何でも質問してください…",
  "Chat Badge": "チャットバッジ",
  "Mute user": "ユーザーをミュート",
  "Unmute user": "ミュートを解除",
  "Voice call": "音声通話",
  "Video call": "ビデオ通話",
  "Incoming call": "着信中",
  "Outgoing call": "発信中",
  "Missed call": "不在着信",
  "Accept call": "通話に応答",
  "Decline call": "通話を拒否",
  "Calling...": "発信中…",
  "Connecting...": "接続中…",
  "Camera permission denied": "カメラの使用が許可されていません",
  "Microphone permission denied": "マイクの使用が許可されていません",
  "Allow camera access": "カメラへのアクセスを許可",
  "Allow microphone access": "マイクへのアクセスを許可",
  "Your browser does not support this feature": "お使いのブラウザはこの機能に対応していません",
  "Start recording": "録音を開始",
  "Stop recording": "録音を停止",
  "Recording": "録音中",
  "Voice message sent": "音声メッセージを送信しました",
  "Could not record audio": "音声を録音できませんでした",
  "Could not access microphone": "マイクにアクセスできませんでした",
  "Delete recording": "録音を削除",
  "Preview": "プレビュー",
  "Preview unavailable": "プレビューを利用できません",
  "Anonymous Questions": "匿名の質問",
  "Ask a question": "質問する",
  "Send anonymously": "匿名で送信",
  "Your answer": "あなたの回答",
  "Write your answer...": "回答を入力…",
  "Answer sent": "回答を送信しました",
  "Question sent": "質問を送信しました",
  "No questions yet": "質問はまだありません",
  "No answers yet": "回答はまだありません",
  "Hide answer": "回答を非表示",
  "Show answer": "回答を表示",
  "Delete question": "質問を削除",
  "Delete answer": "回答を削除",
  "This question is anonymous": "この質問は匿名です",
  "Public answer": "公開回答",
  "Private answer": "非公開回答",
  "This content was removed by moderation": "このコンテンツはモデレーションにより削除されました",
  "Content removed": "コンテンツを削除しました",
  "User banned": "ユーザーをBANしました",
  "User unbanned": "ユーザーのBANを解除しました",
  "Ban lifted": "BANが解除されました",
  "Temporary timeout": "一時的な利用停止",
  "Timeout user": "ユーザーを一時停止",
  "Remove timeout": "利用停止を解除",
  "Timeout duration": "利用停止期間",
  "Custom duration": "カスタム期間",
  "Permanent": "永久",
  "Temporary": "一時的",
  "Never": "なし",
  "1 minute": "1分",
  "5 minutes": "5分",
  "10 minutes": "10分",
  "15 minutes": "15分",
  "30 minutes": "30分",
  "1 hour": "1時間",
  "6 hours": "6時間",
  "12 hours": "12時間",
  "24 hours": "24時間",
  "7 days": "7日間",
  "30 days": "30日間",
  "365 days": "365日間",
  "Reason for report": "報告理由",
  "Reason for ban": "BANの理由",
  "Reason for timeout": "利用停止の理由",
  "No reason given": "理由が入力されていません",
  "Are you sure you want to delete this message?": "このメッセージを削除してもよろしいですか？",
  "Are you sure you want to remove this content?": "このコンテンツを削除してもよろしいですか？",
  "Are you sure you want to ban this user?": "このユーザーをBANしてもよろしいですか？",
  "This user will not be able to access Yaprio.": "このユーザーはYaprioにアクセスできなくなります。",
  "This user will be able to access Yaprio again.": "このユーザーは再びYaprioにアクセスできるようになります。",
  "Confirm ban": "BANを確定",
  "Confirm timeout": "利用停止を確定",
  "Confirm deletion": "削除を確定",
  "Confirm removal": "削除を確定",
  "No reports yet": "報告はまだありません",
  "No messages to show": "表示するメッセージはありません",
  "No users to show": "表示するユーザーはいません",
  "Loading reports...": "報告を読み込み中…",
  "Loading users...": "ユーザーを読み込み中…",
  "Loading messages...": "メッセージを読み込み中…",
  "Could not load reports": "報告を読み込めませんでした",
  "Could not load users": "ユーザーを読み込めませんでした",
  "Review report": "報告を確認",
  "View report": "報告を見る",
  "View message": "メッセージを見る",
  "View user": "ユーザーを見る",
  "Open report": "報告を開く",
  "Dismiss report": "報告を閉じる",
  "Resolve report": "報告を解決済みにする",
  "Reopen report": "報告を再開",
  "Mark resolved": "解決済みにする",
  "Mark pending": "保留中にする",
  "Action required": "対応が必要",
  "No action required": "対応不要",
  "Account permanently banned": "アカウントは永久BANされました",
  "Account temporarily banned": "アカウントは一時的にBANされました",
  "IP address banned": "IPアドレスをBANしました",
  "Delete associated content": "関連コンテンツを削除",
  "Also delete their posts": "投稿も削除",
  "Also delete their messages": "メッセージも削除",
  "Ban this user": "このユーザーをBAN",
  "Unban this user": "このユーザーのBANを解除",
  "Permanently ban": "永久BAN",
  "Temporarily ban": "一時BAN",
  "Give a timeout": "一時利用停止にする",
  "Ban expires at": "BANの有効期限",
  "No expiration": "期限なし",
  "Duration in minutes": "期間（分）",
  "Reason for action": "操作理由",
  "Admin note": "管理者メモ",
  "Internal note": "内部メモ",
  "Visible to user": "ユーザーに表示",
  "Only admins can see this": "管理者のみ閲覧できます",
  "Changes saved successfully": "変更を保存しました",
  "Settings updated": "設定を更新しました",
  "Settings reset": "設定をリセットしました",
  "Username is required": "ユーザー名は必須です",
  "Username must be at least 3 characters long": "ユーザー名は3文字以上で入力してください",
  "Username can be up to 20 characters": "ユーザー名は20文字以内にしてください",
  "Only letters, numbers, and underscores are allowed": "英字、数字、アンダースコアのみ使用できます",
  "This username is already taken": "このユーザー名はすでに使用されています",
  "Your username has been changed": "ユーザー名を変更しました",
  "You can change your username again later": "後でもう一度ユーザー名を変更できます",
  "Please wait before changing your username again": "次にユーザー名を変更するまでお待ちください",
  "Enter your current password": "現在のパスワードを入力",
  "Enter your new password": "新しいパスワードを入力",
  "Confirm your new password": "新しいパスワードを確認",
  "Passwords must match": "パスワードが一致する必要があります",
  "Current password is incorrect": "現在のパスワードが正しくありません",
  "Password changed successfully": "パスワードを変更しました",
  "Could not change password": "パスワードを変更できませんでした",
  "This will permanently delete your account and data.": "アカウントとデータが完全に削除されます。",
  "Your account cannot be recovered after deletion.": "削除後、アカウントは復元できません。",
  "Type your password to confirm": "確認のためパスワードを入力してください",
  "Account deletion is permanent": "アカウントの削除は取り消せません",
  "Delete account": "アカウントを削除",
  "Could not delete account": "アカウントを削除できませんでした",
  "Account deleted successfully": "アカウントを削除しました",
  "Privacy settings saved": "プライバシー設定を保存しました",
  "Could not save privacy settings": "プライバシー設定を保存できませんでした",
  "Profile visibility updated": "プロフィールの公開範囲を更新しました",
  "Only friends": "友達のみ",
  "Everyone except blocked users": "ブロックしたユーザー以外の全員",
  "No one": "誰にも許可しない",
  "Allow": "許可",
  "Don't allow": "許可しない",
  "Allow anyone": "誰でも許可",
  "Disable feature": "機能を無効にする",
  "Enable feature": "機能を有効にする",
  "Meet a random Yaprio member. You can skip, report, or block at any time.": "Yaprioのメンバーとランダムにビデオチャット。いつでもスキップ、報告、ブロックできます。",
  "Connecting video…": "ビデオに接続中…",
  "Your camera preview": "カメラのプレビュー",
  "Camera on · mic off": "カメラオン・マイクオフ",
  "Public Chat Designer": "パブリックチャットのデザイナー",
  "Editing the real Yaprio chat": "実際のYaprioチャットを編集中",
  "Close designer": "デザイナーを閉じる",
  "e.g., borderline hate speech, unsure about intent…": "例：ヘイトスピーチの可能性、意図が不明…",
  "Select any additional permanent actions. The account is permanently banned either way.": "必要に応じて追加の永久措置を選択してください。いずれの場合もアカウントは永久にBANされます。",
  "IP ban": "IP BAN",
  "Why is this account being banned?": "このアカウントをBANする理由",
  "Why are you timing them out?": "一時利用停止にする理由",
  "Maximum: 365 days.": "最大：365日。",
  "Custom duration (minutes)": "カスタム期間（分）",
  "Delete message": "メッセージを削除",
  "Report to Admin": "管理者に報告",
  "Escalate to administrators": "管理者にエスカレーション",
  "Escalate": "エスカレーション",
  "Details:": "詳細：",
  "Reported by": "報告者",
  "message removed": "メッセージを削除しました",
  "author banned": "投稿者はBANされています",
  "Close welcome message": "ウェルカムメッセージを閉じる",
  "Skip": "スキップ",
  "Next": "次へ",
  "Report": "報告",
  "Block": "ブロック",
  "Cancel": "キャンセル",
  "Reason": "理由",
  "Duration": "期間",
  "Unit": "単位",
  "Minutes": "分",
  "Hours": "時間",
  "Days": "日",
  "Reset": "リセット",
  "Desktop": "デスクトップ",
  "Mobile": "モバイル",
  "Dismiss": "閉じる",
  "Mark reviewed": "確認済みにする",
  "Report content": "コンテンツを報告",
  "Content report": "コンテンツの報告",
  "Reported content": "報告されたコンテンツ",
  "This report has been reviewed": "この報告は確認済みです",
  "No reason provided": "理由が入力されていません",
  "No additional details": "追加の詳細はありません",
  "User details": "ユーザー情報",
  "Message details": "メッセージの詳細",
  "Report details": "報告の詳細",
  "Reported user": "報告対象のユーザー",
  "Reported message": "報告されたメッセージ",
  "Reported post": "報告された投稿",
  "Reported story": "報告されたストーリー",
  "Review status": "確認状況",
  "Pending review": "確認待ち",
  "Review complete": "確認完了",
  "View details": "詳細を見る",
  "Take action": "対応する",
  "No action": "対応しない",
  "Delete content": "コンテンツを削除",
  "Remove content": "コンテンツを削除",
  "Ban account": "アカウントをBAN",
  "Timeout account": "アカウントを一時停止",
  "Block user": "ユーザーをブロック",
  "Remove ban": "BANを解除",
  "Confirm action": "操作を確認",
  "Are you sure you want to proceed?": "続行してもよろしいですか？",
  "This action is permanent.": "この操作は取り消せません。",
  "User has been banned": "ユーザーをBANしました",
  "User has been timed out": "ユーザーを一時停止しました",
  "Report dismissed": "報告を却下しました",
  "Report resolved": "報告を解決済みにしました",
  "Report escalated": "報告をエスカレーションしました",
  "Content deleted": "コンテンツを削除しました",
  "Timeout removed": "一時利用停止を解除しました",
  "Ban removed": "BANを解除しました",
  "Failed to ban user": "ユーザーのBANに失敗しました",
  "Failed to remove ban": "BANの解除に失敗しました",
  "Failed to delete content": "コンテンツの削除に失敗しました",
  "Failed to resolve report": "報告を解決できませんでした",
  "Failed to escalate report": "報告のエスカレーションに失敗しました",
  "No active reports": "対応中の報告はありません",
  "No reports found": "報告が見つかりません",
  "No matching reports": "一致する報告はありません",
  "Search reports": "報告を検索",
  "Filter reports": "報告を絞り込む",
  "All reports": "すべての報告",
  "Unresolved": "未解決",
  "Resolved": "解決済み",
  "Escalated": "エスカレーション済み",
  "Dismissed": "却下済み",
  "All statuses": "すべてのステータス",
  "All priorities": "すべての優先度",
  "All types": "すべての種類",
  "Select status": "ステータスを選択",
  "Select priority": "優先度を選択",
  "Select duration": "期間を選択",
  "Select reason": "理由を選択",
  "Enter a reason...": "理由を入力…",
  "Add a note...": "メモを追加…",
  "Optional note": "任意のメモ",
  "No notes yet": "メモはまだありません",
  "No history available": "履歴はありません",
  "Activity history": "アクティビティ履歴",
  "Moderation history": "モデレーション履歴",
  "Admin actions": "管理者の操作",
  "Confirm permanent ban": "永久BANを確定",
  "Confirm temporary ban": "一時BANを確定",
  "Permanently ban this account": "このアカウントを永久BAN",
  "Temporarily ban this account": "このアカウントを一時BAN",
  "Ban duration (days)": "BAN期間（日）",
  "Timeout duration (minutes)": "一時停止期間（分）",
  "Delete all posts": "すべての投稿を削除",
  "Delete all messages": "すべてのメッセージを削除",
  "Delete this user's content": "このユーザーのコンテンツを削除",
  "Account will be permanently banned": "アカウントは永久BANされます",
  "Account will be temporarily banned": "アカウントは一時BANされます",
  "This user is already banned": "このユーザーはすでにBANされています",
  "This user is not banned": "このユーザーはBANされていません",
  "Ban updated": "BANを更新しました",
  "Ban created": "BANを設定しました",
  "Timeout created": "一時利用停止を設定しました",
  "Timeout updated": "一時利用停止を更新しました",
  "Reason is required": "理由を入力してください",
  "Please provide a reason for this action": "この操作の理由を入力してください",
  "Enter the number of minutes": "分数を入力してください",
  "Enter a valid duration": "有効な期間を入力してください",
  "Duration must be positive": "期間は正の値にしてください",
  "Maximum duration is 365 days": "最大期間は365日です",
  "Ban options": "BANのオプション",
  "Additional actions": "追加の操作",
  "Delete account permanently": "アカウントを完全に削除",
  "Permanently delete account": "アカウントを完全に削除",
  "Delete associated posts and messages": "関連する投稿とメッセージを削除",
  "Add": "追加",
  "soon": "近日公開",
  "Who can call you": "通話できる人",
  "is released for anyone else to claim.": "他の人が使用できるようになります。",
  "Your @username is your only identity on Yaprio. Your profile URL will change to": "Yaprioでは@ユーザー名が唯一の識別情報です。プロフィールURLは次のように変更されます：",
  "and you can change it again in 7 days.": "また変更できるのは7日後です。",
  "Your profile URL will change to": "プロフィールURLが次のように変更されます：",
  "Your existing chats, friends, and messages stay with you. You won't be able to change it again for 7 days.": "これまでのチャット、友達、メッセージはそのまま残ります。次に変更できるのは7日後です。",
  "Available!": "使用できます！",
  "Yes, change it": "はい、変更します",
  "newusername": "新しいユーザー名",
  "Post attachment": "投稿の添付ファイル",
  "Selected post": "選択した投稿",
  "Story being replied to": "返信先のストーリー",
  "Sent photo": "送信した写真",
  "Your profile banner": "プロフィールバナー",
  "Couldn\\'t load profile": "プロフィールを読み込めませんでした",
  "This account doesn\\'t exist or is unavailable.": "このアカウントは存在しないか、利用できません。",
  "Profile banner": "プロフィールバナー",
  "Profile picture": "プロフィール画像",
  "User avatar": "ユーザーのアバター",
  "Group avatar": "グループのアバター",
  "Loading role settings…": "ロール設定を読み込み中…",
  "Loading perk settings…": "特典設定を読み込み中…",
  "Please enter a new username": "新しいユーザー名を入力してください",
  "Please enter your username": "ユーザー名を入力してください",
  "Username updated": "ユーザー名を更新しました",
  "Username change successful": "ユーザー名を変更しました",
  "You can change your username again in 7 days.": "ユーザー名は7日後に再び変更できます。",
  "You can change your username again in": "次にユーザー名を変更できるまで",
  "days.": "日です。",
  "The username will be released for anyone else to claim.": "このユーザー名は他の人が使用できるようになります。",
  "This username will be released for anyone else to claim.": "このユーザー名は他の人が使用できるようになります。",
  "Your account and all associated data will be permanently deleted.": "アカウントと関連するすべてのデータが完全に削除されます。",
  "This action is irreversible.": "この操作は取り消せません。",
  "Are you sure you want to delete your account?": "本当にアカウントを削除しますか？",
  "Delete my account permanently": "アカウントを完全に削除",
  "I understand, delete my account": "理解しました。アカウントを削除します",
  "Account deletion": "アカウントの削除",
  "Danger Zone": "危険な操作",
  "Public chat": "パブリックチャット",
  "Private chat": "プライベートチャット",
  "Voice recording": "音声録音",
  "Message composer": "メッセージ入力欄",
  "Search input": "検索欄",
  "Profile picture upload": "プロフィール画像のアップロード",
  "Banner upload": "バナーのアップロード",
  "Open profile menu": "プロフィールメニューを開く",
  "Close profile menu": "プロフィールメニューを閉じる",
  "Toggle navigation": "ナビゲーションを切り替える",
  "Open notifications": "通知を開く",
  "Close notifications": "通知を閉じる",
  "Open messages": "メッセージを開く",
  "Close messages": "メッセージを閉じる",
  "Open settings": "設定を開く",
  "Close settings": "設定を閉じる",
  "Open menu": "メニューを開く",
  "Close menu": "メニューを閉じる",
  "Loading profile…": "プロフィールを読み込み中…",
  "Loading friends…": "友達を読み込み中…",
  "Loading posts…": "投稿を読み込み中…",
  "Loading stories…": "ストーリーを読み込み中…",
  "Loading messages…": "メッセージを読み込み中…",
  "Loading notifications…": "通知を読み込み中…",
  "Loading…": "読み込み中…",
  "No more results": "これ以上の結果はありません",
  "End of results": "結果は以上です",
  "No more messages": "これ以上メッセージはありません",
  "No more posts": "これ以上投稿はありません",
  "No more notifications": "これ以上通知はありません",
  "You reached the end": "最後まで表示しました",
  "Back to chat": "チャットに戻る",
  "Back to messages": "メッセージに戻る",
  "Back to profile": "プロフィールに戻る",
  "Back to home": "ホームに戻る",
  "Return to home": "ホームに戻る",
  "Return to login": "ログインに戻る",
  "You are all caught up": "すべて確認しました",
  "Nothing new": "新しい項目はありません",
  "Nothing to show": "表示するものはありません",
  "No activity to show": "表示するアクティビティはありません",
  "No friends to display": "表示する友達はいません",
  "No posts to display": "表示する投稿はありません",
  "No stories to display": "表示するストーリーはありません",
  "No messages to display": "表示するメッセージはありません",
  "No notifications to display": "表示する通知はありません",
  "No search results": "検索結果はありません",
  "No matches found.": "一致するものが見つかりません。",
  "Try again": "もう一度お試しください",
  "Please wait": "お待ちください",
  "Working...": "処理中…",
  "Processing...": "処理中…",
  "Please wait...": "お待ちください…",
  "Almost done...": "もうすぐ完了します…",
  "Finishing up...": "仕上げています…",
  "One moment...": "少々お待ちください…",
  "Please try again": "もう一度お試しください",
  "An unexpected error occurred": "予期しないエラーが発生しました",
  "An error occurred": "エラーが発生しました",
  "We couldn't complete your request": "リクエストを完了できませんでした",
  "Unable to complete request": "リクエストを完了できません",
  "Something went wrong. Please try again.": "問題が発生しました。もう一度お試しください。",
  "Your changes could not be saved": "変更を保存できませんでした",
  "Your message could not be sent": "メッセージを送信できませんでした",
  "Your post could not be published": "投稿を公開できませんでした",
  "Your photo could not be uploaded": "写真をアップロードできませんでした",
  "Your profile could not be loaded": "プロフィールを読み込めませんでした",
  "Your settings could not be loaded": "設定を読み込めませんでした",
  "Unable to connect to the server": "サーバーに接続できません",
  "Server unavailable": "サーバーを利用できません",
  "Please check your connection": "接続を確認してください",
  "Your connection was interrupted": "接続が中断されました",
  "Connection interrupted": "接続が中断されました",
  "Disconnected": "切断されました",
  "Reconnecting…": "再接続中…",
  "Connection restored": "接続が復旧しました",
  "You're back online": "オンラインに復帰しました",
  "Offline mode": "オフラインモード",
  "Online status": "オンライン状態",
  "Last active status": "最終アクティブ状態",
  "Update profile": "プロフィールを更新",
  "Update settings": "設定を更新",
  "Update username": "ユーザー名を更新",
  "Update password": "パスワードを更新",
  "Change profile picture": "プロフィール画像を変更",
  "Change profile banner": "プロフィールバナーを変更",
  "Remove profile picture": "プロフィール画像を削除",
  "Remove profile banner": "プロフィールバナーを削除",
  "Upload a profile picture": "プロフィール画像をアップロード",
  "Upload a banner": "バナーをアップロード",
  "Choose a photo": "写真を選択",
  "Select a photo": "写真を選択",
  "Select an image": "画像を選択",
  "Drag and drop a file here": "ここにファイルをドラッグ＆ドロップ",
  "Browse files": "ファイルを参照",
  "Choose from gallery": "ギャラリーから選択",
  "Take a photo": "写真を撮影",
  "Camera unavailable": "カメラを利用できません",
  "Microphone unavailable": "マイクを利用できません",
  "Permission required": "権限が必要です",
  "Grant permission": "権限を許可",
  "Try again later": "後でもう一度お試しください",
  "This feature is not available yet": "この機能はまだ利用できません",
  "Feature unavailable": "この機能は利用できません",
  "Under development": "開発中",
  "More features coming soon": "さらに多くの機能を近日公開予定",
  "Coming soon": "近日公開",
  "Stay tuned": "続報をお待ちください",
  "403 — Access denied": "403 — アクセスが拒否されました",
  "This area is restricted to Yaprio moderators.": "このエリアはYaprioのモデレーター専用です。",
  "Signing you in…": "ログイン中…",
  "Video": "ビデオ",
  "View profile photo": "プロフィール写真を見る",
  "Profile photo": "プロフィール写真",
  "Close photo": "写真を閉じる",
  "Copy text": "テキストをコピー",
  "Copy message link": "メッセージリンクをコピー",
  "Remove as moderator": "モデレーターから削除",
  "More reactions": "ほかのリアクション",
  "Restore call": "通話に戻る",
  "End call": "通話を終了",
  "Minimize call": "通話を最小化",
  "Flip camera": "カメラを切り替える",
  "Call connection lost": "通話の接続が切れました",
  "Could not establish a direct connection": "直接接続を確立できませんでした",
  "You're already in a call": "すでに通話中です",
  "Turn on your camera first.": "先にカメラをオンにしてください。",
  "The video connection is not ready yet. Try again in a moment.": "ビデオ接続の準備がまだできていません。少し待ってからもう一度お試しください。",
  "Call declined": "通話を拒否しました",
  "Caller cancelled": "発信者がキャンセルしました",
  "Call ended": "通話が終了しました",
  "Drag call": "通話をドラッグ",
  "Call incoming": "着信中",
  "Accept incoming call": "着信に応答",
  "Decline incoming call": "着信を拒否",
  "Switch camera": "カメラを切り替える",
  "Turn camera on": "カメラをオンにする",
  "Turn camera off": "カメラをオフにする",
  "Mute microphone": "マイクをミュート",
  "Unmute microphone": "マイクのミュートを解除",
  "Speaker": "スピーカー",
  "Speaker on": "スピーカーオン",
  "Speaker off": "スピーカーオフ",
  "Call controls": "通話コントロール",
  "Call settings": "通話設定",
  "Connecting call…": "通話に接続中…",
  "Reconnecting call…": "通話に再接続中…",
  "Call failed": "通話に失敗しました",
  "Call timed out": "通話がタイムアウトしました",
  "No answer": "応答がありません",
  "Busy": "通話中",
  "Your call was declined": "通話が拒否されました",
  "Your call has ended": "通話が終了しました",
  "Call started": "通話を開始しました",
  "Call connected": "通話が接続されました",
  "Video enabled": "ビデオを有効にしました",
  "Video disabled": "ビデオを無効にしました",
  "Audio enabled": "音声を有効にしました",
  "Audio disabled": "音声を無効にしました",
  "Allow camera access to make a video call.": "ビデオ通話を行うにはカメラへのアクセスを許可してください。",
  "Allow microphone access to make a call.": "通話を行うにはマイクへのアクセスを許可してください。",
  "Your camera is unavailable.": "カメラを利用できません。",
  "Your microphone is unavailable.": "マイクを利用できません。",
  "Screen share": "画面共有",
  "Start screen share": "画面共有を開始",
  "Stop screen share": "画面共有を停止",
  "Share screen": "画面を共有",
  "Stop sharing": "共有を停止",
  "Connection quality": "接続品質",
  "Poor connection": "接続状態が不安定です",
  "Call duration": "通話時間",
  "Post link copied": "投稿リンクをコピーしました",
  "Please choose an image.": "画像を選択してください。",
  "Image must be 5MB or smaller.": "画像は5MB以下にしてください。",
  "Story image must be 25MB or smaller.": "ストーリー画像は25MB以下にしてください。",
  "Story posted for 24 hours 💗": "ストーリーを投稿しました（24時間表示）💗",
  "Story deleted": "ストーリーを削除しました",
  "Could not load friends": "友達を読み込めませんでした",
  "Give your group a name.": "グループ名を入力してください。",
  "Select at least one friend.": "友達を1人以上選択してください。",
  "Group photo updated": "グループ写真を更新しました",
  "Group deleted": "グループを削除しました",
  "Left group": "グループを退出しました",
  "Group name must be at least 2 characters.": "グループ名は2文字以上にしてください。",
  "Group updated": "グループを更新しました",
  "The other player closed the game.": "相手がゲームを終了しました。",
  "Could not delete message": "メッセージを削除できませんでした",
  "Message removed for everyone": "全員のメッセージを削除しました",
  "GIF picker coming next": "GIF選択機能は今後追加予定です",
  "Role settings saved.": "ロール設定を保存しました。",
  "Profile appearance saved.": "プロフィールの外観を保存しました。",
  "Profile banner uploaded.": "プロフィールバナーをアップロードしました。",
  "Profile banner removed.": "プロフィールバナーを削除しました。",
  "Avatar ring saved.": "アバターリングを保存しました。",
  "Perk settings saved.": "特典設定を保存しました。",
  "Purchased successfully!": "購入しました！",
  "Enter a username and valid amount.": "ユーザー名と有効な金額を入力してください。",
  "You do not have enough YC for this transfer.": "送金に必要なYCが不足しています。",
  "Photo removed": "写真を削除しました",
  "Game found!": "ゲームが見つかりました！",
  "Could not load profile": "プロフィールを読み込めませんでした",
  "Could not load notifications": "通知を読み込めませんでした",
  "Could not load messages": "メッセージを読み込めませんでした",
  "Could not load posts": "投稿を読み込めませんでした",
  "Could not load stories": "ストーリーを読み込めませんでした",
  "Could not update profile": "プロフィールを更新できませんでした",
  "Could not update settings": "設定を更新できませんでした",
  "Could not save profile": "プロフィールを保存できませんでした",
  "Could not save settings": "設定を保存できませんでした",
  "Could not upload photo": "写真をアップロードできませんでした",
  "Could not upload image": "画像をアップロードできませんでした",
  "Could not post story": "ストーリーを投稿できませんでした",
  "Could not delete story": "ストーリーを削除できませんでした",
  "Could not create group": "グループを作成できませんでした",
  "Could not update group": "グループを更新できませんでした",
  "Could not delete group": "グループを削除できませんでした",
  "Could not leave group": "グループを退出できませんでした",
  "Message removed": "メッセージを削除しました",
  "Role settings saved": "ロール設定を保存しました",
  "Profile appearance saved": "プロフィールの外観を保存しました",
  "Perk settings saved": "特典設定を保存しました",
  "Purchase failed": "購入に失敗しました",
  "Transfer sent": "送金しました",
  "Transfer failed": "送金に失敗しました",
  "Please enter a valid amount": "有効な金額を入力してください",
  "Please enter a username": "ユーザー名を入力してください",
  "This user cannot receive transfers": "このユーザーは送金を受け取れません",
  "You cannot send YC to yourself": "自分自身にYCを送ることはできません",
  "YC transfer successful": "YCを送金しました",
  "No friends to add": "追加できる友達はいません",
  "Group created": "グループを作成しました",
  "Could not update group photo": "グループ写真を更新できませんでした",
  "Could not remove photo": "写真を削除できませんでした",
  "Could not update avatar ring": "アバターリングを更新できませんでした",
  "Could not save role settings": "ロール設定を保存できませんでした",
  "Could not save perk settings": "特典設定を保存できませんでした",
  "Turn all notification alerts on or off.": "すべての通知をオンまたはオフにします。",
  "Avatar ring color": "アバターリングの色",
  "Buy perks from Wallet & Store to customize your profile and chats.": "ウォレット＆ストアで特典を購入して、プロフィールやチャットをカスタマイズしましょう。",
  "Turn your selected effect on or off.": "選択したエフェクトをオンまたはオフにします。",
  "Question reported and sender blocked": "質問を報告し、送信者をブロックしました",
  "Question deleted": "質問を削除しました",
  "Question sent anonymously": "匿名で質問を送信しました",
  "Questions & Answers": "質問と回答",
  "Questions are anonymous to you, while Yaprio keeps internal abuse-prevention records.": "質問はあなたには匿名で表示されます。Yaprioは不正利用防止のための内部記録を保持します。",
  "Answered anonymously for everyone to see.": "匿名で回答しました。回答は全員に表示されます。",
  "No anonymous questions yet.": "匿名の質問はまだありません。",
  "No answered questions yet.": "回答済みの質問はまだありません。",
  "The other person left. Finding someone else…": "相手が退出しました。別の相手を探しています…",
  "Report submitted. Leaving this match for your safety.": "報告を送信しました。安全のため、このマッチングを終了します。",

  // Follow-up audit: wallet/store catalog, own profile, message status and settings.
  "Your Profile": "あなたのプロフィール",
  "This is how the world sees you on Yaprio.": "Yaprioで他の人に表示されるプロフィールです。",
  "Level": "レベル",
  "XP total": "累計XP",
  "achievements": "個の実績",
  "MAX LEVEL": "最大レベル",
  "Your profile banner preview": "プロフィールバナーのプレビュー",
  "Replace banner": "バナーを変更",
  "Upload banner": "バナーをアップロード",
  "Add photo": "写真を追加",
  "First Words": "最初の言葉",
  "Send your first message.": "最初のメッセージを送信する。",
  "Chatterbox": "おしゃべり好き",
  "Send 100 messages.": "メッセージを100件送信する。",
  "Yap Legend": "Yapの伝説",
  "Send 1,000 messages.": "メッセージを1,000件送信する。",
  "Good Friend": "良き友達",
  "Send YC to another member.": "ほかのメンバーにYCを送る。",
  "Collector": "コレクター",
  "Buy your first role or perk.": "最初のロールまたは特典を購入する。",
  "Unlocked": "解除済み",
  "permanent": "無期限",
  "days": "日間",
  "Owned": "所有済み",
  "Buy": "購入",
  "Store": "ストア",
  "Send YC": "YCを送る",
  "History": "履歴",
  "Aurora": "オーロラ",
  "A flowing neon gradient ring.": "流れるネオンのグラデーションリング。",
  "Blaze": "ブレイズ",
  "A warm flame-inspired ring.": "炎をイメージした暖かなリング。",
  "Volt": "ボルト",
  "An electric-blue pulse ring.": "電気のような青いパルスリング。",
  "Orbit": "オービット",
  "A glowing orbiting-light ring.": "光が周回する輝くリング。",
  "Nova": "ノヴァ",
  "A gold segmented glow ring.": "金色のセグメントが輝くリング。",
  "Ghost Mode": "ゴーストモード",
  "Hide read receipts while reading messages.": "メッセージを読んでいる間、既読通知を非表示にします。",
  "Username Color": "ユーザー名の色",
  "Unlock premium username styling.": "プレミアムなユーザー名スタイルを解除します。",
  "Profile Frame": "プロフィールフレーム",
  "Show your premium frame around your profile photo.": "プロフィール写真の周りにプレミアムフレームを表示します。",
  "Chat Badge": "チャットバッジ",
  "Show the chat badge beside your username.": "ユーザー名の横にチャットバッジを表示します。",
  "Confirm purchase": "購入の確認",
  "Are you sure you want to buy": "本当に購入しますか：",
  "for": "価格：",
  "This will deduct the YC from your wallet.": "ウォレットからYCが差し引かれます。",
  "Cancel": "キャンセル",
  "Buying…": "購入中…",
  "Yes, buy it": "はい、購入する",
  "Amount of YC · Balance": "YCの数量 · 残高",
  "Sending…": "送信中…",
  "First Words": "最初の言葉",
  "Friend requests": "友達リクエスト",
  "Manage notifications and alerts.": "通知とアラートを管理します。",
  "Privacy": "プライバシー",
  "Control who can see your content and contact you.": "コンテンツの閲覧や連絡ができる相手を管理します。",
  "Roles & Abilities": "ロールと機能",
  "Enable, disable and customize your active role.": "使用中のロールと機能を有効化、無効化、カスタマイズします。",
  "Perks & Styling": "特典とスタイル",
  "Manage active perks, username color and chat cosmetics.": "有効な特典、ユーザー名の色、チャットの装飾を管理します。",
  "Account": "アカウント",
  "Manage your account details and security.": "アカウント情報とセキュリティを管理します。",
  "Language": "言語",
  "Choose your preferred language.": "使用する言語を選択します。",
  "Theme & Display": "テーマと表示",
  "Customize your Yaprio experience.": "Yaprioの表示をカスタマイズします。",
  "About": "情報",
  "Version, help and more.": "バージョン、ヘルプなど。",
  "Choose which alerts Yaprio can show you on this device.": "このデバイスでYaprioから受け取る通知を選択します。",
  "Turn all notification alerts on or off.": "すべての通知をオンまたはオフにします。",
  "Requests and friend request updates.": "友達リクエストとその更新。",
  "New message notifications.": "新しいメッセージの通知。",
  "Incoming and missed call alerts.": "着信と不在着信の通知。",
  "Social activity": "ソーシャルアクティビティ",
  "Likes, comments and other activity.": "いいね、コメント、その他のアクティビティ。",
  "Your choices are saved automatically on this device.": "設定はこのデバイスに自動保存されます。",
  "Control who can see you and who can contact you. Changes save automatically.": "あなたのプロフィールを閲覧できる人や連絡できる人を管理します。変更は自動保存されます。",
  "Profile visibility": "プロフィールの公開範囲",
  "Choose who can open your profile.": "プロフィールを閲覧できる人を選択します。",
  "Photo visibility": "写真の公開範囲",
  "Control who can view your profile gallery.": "プロフィールギャラリーを閲覧できる人を管理します。",
  "Choose whether anyone can send you a request.": "誰でもリクエストを送信できるか選択します。",
  "Private messages": "プライベートメッセージ",
  "Control whether friends can message you.": "友達がメッセージを送信できるか管理します。",
  "Control who can call you.": "通話できる相手を管理します。",
  "Random video chat": "ランダムビデオチャット",
  "Allow Yaprio to match you with other members in Random Video Chat.": "Yaprioがランダムビデオチャットでほかのメンバーとマッチングできるようにします。",
  "Loading privacy settings…": "プライバシー設定を読み込み中…",
  "Loading role settings…": "ロール設定を読み込み中…",
  "You don't currently own a role. Buy one from Wallet & Store to unlock role abilities.": "現在ロールを所有していません。ウォレット＆ストアで購入するとロールの機能を利用できます。",
  "Your role lasts 30 days. Turn it off or disable individual abilities whenever you want.": "ロールの有効期間は30日間です。いつでもロール全体や個別の機能を無効にできます。",
  "Role profile perks": "ロールのプロフィール特典",
  "Please wait…": "お待ちください…",
  "Replace profile banner": "プロフィールバナーを変更",
  "Upload profile banner": "プロフィールバナーをアップロード",
  "Banner uploaded": "バナーをアップロードしました",
  "Remove banner": "バナーを削除",
  "No active perks": "有効な特典はありません",
  "Turn your active perks on or off. Every perk lasts 30 days from purchase.": "有効な特典をオン・オフできます。特典は購入から30日間有効です。",
  "Username color": "ユーザー名の色",
  "Last seen about 9 hours ago": "最終オンライン：約9時間前",
  "Social activity.": "ソーシャルアクティビティ。",
  "Friend request updates.": "友達リクエストの更新。",
  "Expires": "有効期限",
  "Email & password": "メールアドレスとパスワード",
  "Google account": "Googleアカウント",
  "See friends on other people’s profiles": "他の人のプロフィールで友達を表示",
  "See followers and following on other people’s profiles": "他の人のプロフィールでフォロワーとフォロー中を表示",
  "30 YC daily login bonus": "毎日のログインボーナス30 YC",
  "Up to 200 message YC per day": "1日あたりメッセージで最大200 YC",
  "2× YapCoins per eligible message": "対象メッセージごとにYapCoins 2倍",
  "Everything in Elite": "Eliteのすべての特典",
  "Eligible private-profile viewing": "対象の非公開プロフィールを閲覧",
  "Animated avatar ring designs": "アニメーション付きアバターリング",
  "20 YC daily login bonus": "毎日のログインボーナス20 YC",
  "Up to 175 message YC per day": "1日あたりメッセージで最大175 YC",
  "1.75× YapCoins per eligible message": "対象メッセージごとにYapCoins 1.75倍",
  "Everything in VIP": "VIPのすべての特典",
  "Normal avatar ring": "通常のアバターリング",
  "Custom profile banner": "カスタムプロフィールバナー",
  "VIP badge in profiles and chats": "プロフィールとチャットにVIPバッジ",
  "15 YC daily login bonus": "毎日のログインボーナス15 YC",
  "Up to 150 message YC per day": "1日あたりメッセージで最大150 YC",
  "1.5× YapCoins per eligible message": "対象メッセージごとにYapCoins 1.5倍",
  "Online": "オンライン",
  "Offline": "オフライン",
  "Last seen ": "最終オンライン：",
  "Level 5+ Chat Badge": "レベル5以上のチャットバッジ",
  "about 1 minute ago": "約1分前",
  "about 2 minutes ago": "約2分前",
  "about 1 hour ago": "約1時間前",
  "about 2 hours ago": "約2時間前",
};

const JA_PREFIX = [
  ["Created ", "作成しました："],
  ["Game found! You", "ゲームが見つかりました！あなたは"],
  ["You found a player", "対戦相手が見つかりました"],
];

const JA_DYNAMIC = [
  [/^Open @(.+) profile$/, (m) => "@" + m[1] + " のプロフィールを開く"],
  [/^Follow @(.+) to request access to their profile, posts and gallery\.$/, (m) => "@" + m[1] + " をフォローして、プロフィール、投稿、ギャラリーの閲覧をリクエストしましょう。"],
  [/^You replied to @(.+)'s story$/, (m) => "@" + m[1] + " のストーリーに返信しました"],
  [/^@(.+) has replied to your story$/, (m) => "@" + m[1] + " があなたのストーリーに返信しました"],
  [/^Replying to @(.+)'s story$/, (m) => "@" + m[1] + " のストーリーに返信中"],
  [/^Replying to @(.+)$/, (m) => "@" + m[1] + " に返信中"],
  [/^Reply to @(.+?)(?:…|\.\.\.)$/, (m) => "@" + m[1] + " に返信…"],
  [/^Message (.+?)(?:…|\.\.\.)$/, (m) => m[1] + " にメッセージ…"],
  [/^Delete (.+) for everyone\?$/, (m) => m[1] + " のメッセージを全員から削除しますか？"],
  [/^Leave (.+)\?$/, (m) => m[1] + " を退出しますか？"],
  [/^Friend request sent to @(.+)$/, (m) => "@" + m[1] + " に友達リクエストを送信しました"],
  [/^You're now friends with @(.+)$/, (m) => "@" + m[1] + " と友達になりました"],
  [/^@(.+) blocked$/, (m) => "@" + m[1] + " をブロックしました"],
  [/^@(.+) unblocked$/, (m) => "@" + m[1] + " のブロックを解除しました"],
  [/^Removed @(.+)$/, (m) => "@" + m[1] + " を削除しました"],
  [/^Blocked @(.+)$/, (m) => "@" + m[1] + " をブロックしました"],
  [/^Unblocked @(.+)$/, (m) => "@" + m[1] + " のブロックを解除しました"],
  [/^Demote @(.+) to member\?$/, (m) => "@" + m[1] + " をメンバーに降格しますか？"],
  [/^Promote @(.+) to moderator\?$/, (m) => "@" + m[1] + " をモデレーターに昇格しますか？"],
  [/^Choose ring color (.+)$/, (m) => "リングの色を選択：" + m[1]],
  [/^Enable (.+)$/, (m) => m[1] + " を有効にする"],
  [/^(\d+) active$/, (m) => "アクティブな項目：" + m[1] + "件"],
  [/^(\d+) members$/, (m) => m[1] + "人のメンバー"],
  [/^🎤 Voice message (\d+) secs$/, (m) => "🎤 音声メッセージ " + m[1] + "秒"],
  [/^Amount of YC · Balance: (.+)$/, (m) => "YCの数量 · 残高：" + m[1]],
  [/^· (\d+) days$/, (m) => "· " + m[1] + "日間"],
  [/^less than a minute ago$/, () => "1分未満前"],
  [/^less than (\d+) seconds ago$/, (m) => m[1] + "秒未満前"],
  [/^half a minute ago$/, () => "約30秒前"],
  [/^about a minute ago$/, () => "約1分前"],
  [/^about (\d+) minutes ago$/, (m) => "約" + m[1] + "分前"],
  [/^about an hour ago$/, () => "約1時間前"],
  [/^about (\d+) hours ago$/, (m) => "約" + m[1] + "時間前"],
  [/^about a day ago$/, () => "約1日前"],
  [/^about (\d+) days ago$/, (m) => "約" + m[1] + "日前"],
  [/^about a month ago$/, () => "約1か月前"],
  [/^about (\d+) months ago$/, (m) => "約" + m[1] + "か月前"],
  [/^about a year ago$/, () => "約1年前"],
  [/^about (\d+) years ago$/, (m) => "約" + m[1] + "年前"],
  [/^over (\d+) years ago$/, (m) => m[1] + "年以上前"],
  [/^almost (\d+) years ago$/, (m) => "約" + m[1] + "年前"],
  [/^(\d+) seconds ago$/, (m) => m[1] + "秒前"],
  [/^(\d+) minutes ago$/, (m) => m[1] + "分前"],
  [/^(\d+) hours ago$/, (m) => m[1] + "時間前"],
  [/^(\d+) days ago$/, (m) => m[1] + "日前"],
  [/^(\d+) weeks ago$/, (m) => m[1] + "週間前"],
  [/^(\d+) months ago$/, (m) => m[1] + "か月前"],
  [/^(\d+) years ago$/, (m) => m[1] + "年前"],
  [/^(.+) liked your post$/, (m) => m[1] + " さんがあなたの投稿にいいねしました"],
  [/^(.+) commented on your post$/, (m) => m[1] + " さんがあなたの投稿にコメントしました"],
  [/^(.+) replied to your comment$/, (m) => m[1] + " さんがあなたのコメントに返信しました"],
  [/^(.+) started following you$/, (m) => m[1] + " さんがあなたをフォローしました"],
  [/^(.+) sent you a friend request$/, (m) => m[1] + " さんから友達リクエストが届きました"],
  [/^(.+) accepted your friend request$/, (m) => m[1] + " さんが友達リクエストを承認しました"],
  [/^(.+) mentioned you$/, (m) => m[1] + " さんがあなたにメンションしました"],
  [/^New message from (.+)$/, (m) => m[1] + " さんから新しいメッセージ"],
  [/^(.+) liked your story$/, (m) => m[1] + " さんがあなたのストーリーにいいねしました"],
  [/^(.+) is typing…$/, (m) => m[1] + " さんが入力中…"],
  [/^(.+) is typing\.\.\.$/, (m) => m[1] + " さんが入力中…"],
];

function translateJapanese(value) {
  if (typeof value !== "string") return value;
  if (JA[value]) return JA[value];
  for (const [pattern, render] of JA_DYNAMIC) {
    const match = value.match(pattern);
    if (match) return render(match);
  }
  const transfer = value.match(/^Sent (.+?) YC to @(.+)$/);
  if (transfer) return "送金しました：" + transfer[1] + " YC → @" + transfer[2];
  for (const [prefix, translatedPrefix] of JA_PREFIX) {
    if (value.startsWith(prefix)) return translatedPrefix + value.slice(prefix.length);
  }
  return value;
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === "ja" ? "ja" : "en"; } catch { return "en"; }
  });

  const setLanguage = useCallback((next) => {
    const value = next === "ja" ? "ja" : "en";
    setLanguageState(value);
    try { localStorage.setItem(STORAGE_KEY, value); } catch {}
  }, []);

  useEffect(() => {
    document.documentElement.lang = language === "ja" ? "ja" : "en";
    document.documentElement.dataset.yaprioLanguage = language;
  }, [language]);


  // Translate any remaining exact UI strings that a page/component has not yet
  // routed through t(). Keep originals so switching back to English is lossless.
  useEffect(() => {
    if (typeof document === "undefined" || !document.body) return undefined;
    const originalText = new Map();
    const originalAttrs = new Map();
    const attrs = ["placeholder", "title", "aria-label", "aria-description", "alt", "data-tooltip"];
    const translateText = (node) => {
      if (!node || node.nodeType !== Node.TEXT_NODE) return;
      const parent = node.parentElement;
      if (parent?.closest("textarea, input, [contenteditable='true']")) return;
      // Never translate user-authored posts, comments, bios, or message bodies.
      // Explicit UI labels inside message bubbles can opt back in with data-translate="on".
      const forceTranslate = parent?.closest("[data-translate='on']");
      if (!forceTranslate && parent?.closest(".whitespace-pre-wrap, [data-user-content='true'], [data-translate='off']")) return;
      const raw = node.nodeValue || "";
      const trimmed = raw.trim();
      const translated = translateJapanese(trimmed);
      if (!trimmed || translated === trimmed) return;
      originalText.set(node, raw);
      const start = raw.indexOf(trimmed);
      node.nodeValue = raw.slice(0, start) + translated + raw.slice(start + trimmed.length);
    };
    const translateElement = (el) => {
      if (!el || el.nodeType !== Node.ELEMENT_NODE) return;
      if (el.matches("script,style,code,pre,[contenteditable='true']")) return;
      for (const attr of attrs) {
        const value = el.getAttribute(attr);
        if (value && translateJapanese(value) !== value) {
          const key = el.tagName + ":" + attr;
          if (!originalAttrs.has(el)) originalAttrs.set(el, new Map());
          const saved = originalAttrs.get(el);
          saved.set(key, value);
          el.setAttribute(attr, translateJapanese(value));
        }
      }
      if ((el.tagName === "INPUT" && ["button","submit","reset"].includes((el.type || "").toLowerCase()))) {
        const value = el.getAttribute("value");
        if (value && JA[value]) {
          const key = el.tagName + ":value";
          if (!originalAttrs.has(el)) originalAttrs.set(el, new Map());
          const saved = originalAttrs.get(el);
          saved.set(key, value);
          el.setAttribute("value", translateJapanese(value));
        }
      }
    };
    const scan = (root) => {
      if (!root) return;
      if (root.nodeType === Node.TEXT_NODE) { translateText(root); return; }
      translateElement(root);
      if (root.querySelectorAll) root.querySelectorAll("*").forEach(translateElement);
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) translateText(node);
    };
    if (language === "ja") {
      scan(document.body);
      const observer = new MutationObserver((records) => {
        for (const record of records) {
          if (record.type === "characterData") translateText(record.target);
          for (const added of record.addedNodes || []) scan(added);
          if (record.type === "attributes") translateElement(record.target);
        }
      });
      observer.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: [...attrs, "value"] });
      return () => {
        observer.disconnect();
        originalText.forEach((value, node) => { if (node.isConnected) node.nodeValue = value; });
        originalAttrs.forEach((saved, el) => {
          if (!el.isConnected) return;
          saved.forEach((value, key) => {
            const split = key.indexOf(":");
            el.setAttribute(key.slice(split + 1), value);
          });
        });
      };
    }
    originalText.forEach((value, node) => { if (node.isConnected) node.nodeValue = value; });
    originalAttrs.forEach((saved, el) => {
      if (!el.isConnected) return;
      saved.forEach((value, key) => {
        const split = key.indexOf(":");
        el.setAttribute(key.slice(split + 1), value);
      });
    });
    return undefined;
  }, [language]);

  const t = useCallback((value) => {
    if (language !== "ja" || typeof value !== "string") return value;
    return translateJapanese(value);
  }, [language]);

  const value = useMemo(() => ({ language, setLanguage, t }), [language, setLanguage, t]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  return useContext(LanguageContext);
}

export const LANGUAGE_STORAGE_KEY = STORAGE_KEY;
